export const ALL_SONGS = Object.freeze(
    [
        {
            "artists": [
                {
                    "external_urls": {
                        "spotify": "https://open.spotify.com/artist/2wUjUUtkb5lvLKcGKsKqsR"
                    },
                    "href": "https://api.spotify.com/v1/artists/2wUjUUtkb5lvLKcGKsKqsR",
                    "id": "2wUjUUtkb5lvLKcGKsKqsR",
                    "name": "Alessia Cara",
                    "type": "artist",
                    "uri": "spotify:artist:2wUjUUtkb5lvLKcGKsKqsR"
                },
                {
                    "external_urls": {
                        "spotify": "https://open.spotify.com/artist/2SmW1lFlBJn4IfBzBZDlSh"
                    },
                    "href": "https://api.spotify.com/v1/artists/2SmW1lFlBJn4IfBzBZDlSh",
                    "id": "2SmW1lFlBJn4IfBzBZDlSh",
                    "name": "The Warning",
                    "type": "artist",
                    "uri": "spotify:artist:2SmW1lFlBJn4IfBzBZDlSh"
                }
            ],
            "available_markets": [
                "CA",
                "PR",
                "US"
            ],
            "disc_number": 1,
            "duration_ms": 263693,
            "explicit": false,
            "external_urls": {
                "spotify": "https://open.spotify.com/track/6N2er1oLZUfkcHv4CFHBKl"
            },
            "href": "https://api.spotify.com/v1/tracks/6N2er1oLZUfkcHv4CFHBKl",
            "id": "6N2er1oLZUfkcHv4CFHBKl",
            "is_local": false,
            "name": "Enter Sandman",
            "preview_url": "https://p.scdn.co/mp3-preview/aa58e489edbaaf2aae904e0c8c3a936b59994e22?cid=82a8a496c4904e3ebacd0a69657907e0",
            "track_number": 1,
            "type": "track",
            "uri": "spotify:track:6N2er1oLZUfkcHv4CFHBKl",
            "originals": [
                "3VqHuw0wFlIHcIPWkhIbdQ"
            ]
        },
        {
            "artists": [
                {
                    "external_urls": {
                        "spotify": "https://open.spotify.com/artist/3Sz7ZnJQBIHsXLUSo0OQtM"
                    },
                    "href": "https://api.spotify.com/v1/artists/3Sz7ZnJQBIHsXLUSo0OQtM",
                    "id": "3Sz7ZnJQBIHsXLUSo0OQtM",
                    "name": "Mac DeMarco",
                    "type": "artist",
                    "uri": "spotify:artist:3Sz7ZnJQBIHsXLUSo0OQtM"
                }
            ],
            "available_markets": [
                "CA",
                "PR",
                "US"
            ],
            "disc_number": 1,
            "duration_ms": 346053,
            "explicit": false,
            "external_urls": {
                "spotify": "https://open.spotify.com/track/2CWfmW9Z4C1c5OlwhxKUWF"
            },
            "href": "https://api.spotify.com/v1/tracks/2CWfmW9Z4C1c5OlwhxKUWF",
            "id": "2CWfmW9Z4C1c5OlwhxKUWF",
            "is_local": false,
            "name": "Enter Sandman",
            "preview_url": "https://p.scdn.co/mp3-preview/854a93d79e0d8dfcaee233945efee9cfd4a1f07b?cid=82a8a496c4904e3ebacd0a69657907e0",
            "track_number": 2,
            "type": "track",
            "uri": "spotify:track:2CWfmW9Z4C1c5OlwhxKUWF",
            "originals": [
                "3VqHuw0wFlIHcIPWkhIbdQ"
            ]
        },
        {
            "artists": [
                {
                    "external_urls": {
                        "spotify": "https://open.spotify.com/artist/1Qp56T7n950O3EGMsSl81D"
                    },
                    "href": "https://api.spotify.com/v1/artists/1Qp56T7n950O3EGMsSl81D",
                    "id": "1Qp56T7n950O3EGMsSl81D",
                    "name": "Ghost",
                    "type": "artist",
                    "uri": "spotify:artist:1Qp56T7n950O3EGMsSl81D"
                }
            ],
            "available_markets": [
                "CA",
                "PR",
                "US"
            ],
            "disc_number": 1,
            "duration_ms": 231106,
            "explicit": false,
            "external_urls": {
                "spotify": "https://open.spotify.com/track/2Mg6TK4zFLHIw5F1btV7Cj"
            },
            "href": "https://api.spotify.com/v1/tracks/2Mg6TK4zFLHIw5F1btV7Cj",
            "id": "2Mg6TK4zFLHIw5F1btV7Cj",
            "is_local": false,
            "name": "Enter Sandman",
            "preview_url": "https://p.scdn.co/mp3-preview/42c75849abb4645cef4a51c07fb3597b9788fd0a?cid=82a8a496c4904e3ebacd0a69657907e0",
            "track_number": 3,
            "type": "track",
            "uri": "spotify:track:2Mg6TK4zFLHIw5F1btV7Cj",
            "originals": [
                "3VqHuw0wFlIHcIPWkhIbdQ"
            ]
        },
        {
            "artists": [
                {
                    "external_urls": {
                        "spotify": "https://open.spotify.com/artist/0UWZUmn7sybxMCqrw9tGa7"
                    },
                    "href": "https://api.spotify.com/v1/artists/0UWZUmn7sybxMCqrw9tGa7",
                    "id": "0UWZUmn7sybxMCqrw9tGa7",
                    "name": "Juanes",
                    "type": "artist",
                    "uri": "spotify:artist:0UWZUmn7sybxMCqrw9tGa7"
                }
            ],
            "available_markets": [
                "CA",
                "PR",
                "US"
            ],
            "disc_number": 1,
            "duration_ms": 293040,
            "explicit": false,
            "external_urls": {
                "spotify": "https://open.spotify.com/track/796pDN8Pmax3N35tNB0bYo"
            },
            "href": "https://api.spotify.com/v1/tracks/796pDN8Pmax3N35tNB0bYo",
            "id": "796pDN8Pmax3N35tNB0bYo",
            "is_local": false,
            "name": "Enter Sandman",
            "preview_url": "https://p.scdn.co/mp3-preview/50e306b60db42c8d05ce0c2bfa9ff3e3d2b3ef05?cid=82a8a496c4904e3ebacd0a69657907e0",
            "track_number": 4,
            "type": "track",
            "uri": "spotify:track:796pDN8Pmax3N35tNB0bYo",
            "originals": [
                "3VqHuw0wFlIHcIPWkhIbdQ"
            ]
        },
        {
            "artists": [
                {
                    "external_urls": {
                        "spotify": "https://open.spotify.com/artist/2KEqzdPS7M5YwGmiuPTdr5"
                    },
                    "href": "https://api.spotify.com/v1/artists/2KEqzdPS7M5YwGmiuPTdr5",
                    "id": "2KEqzdPS7M5YwGmiuPTdr5",
                    "name": "Rina Sawayama",
                    "type": "artist",
                    "uri": "spotify:artist:2KEqzdPS7M5YwGmiuPTdr5"
                }
            ],
            "available_markets": [
                "CA",
                "PR",
                "US"
            ],
            "disc_number": 1,
            "duration_ms": 333880,
            "explicit": false,
            "external_urls": {
                "spotify": "https://open.spotify.com/track/6ELBnT2XZQPq3pUjmu3jz8"
            },
            "href": "https://api.spotify.com/v1/tracks/6ELBnT2XZQPq3pUjmu3jz8",
            "id": "6ELBnT2XZQPq3pUjmu3jz8",
            "is_local": false,
            "name": "Enter Sandman",
            "preview_url": "https://p.scdn.co/mp3-preview/673c674de75ea16d2f3a420d78720fde31d89230?cid=82a8a496c4904e3ebacd0a69657907e0",
            "track_number": 5,
            "type": "track",
            "uri": "spotify:track:6ELBnT2XZQPq3pUjmu3jz8",
            "originals": [
                "3VqHuw0wFlIHcIPWkhIbdQ"
            ]
        },
        {
            "artists": [
                {
                    "external_urls": {
                        "spotify": "https://open.spotify.com/artist/3jOstUTkEu2JkjvRdBA5Gu"
                    },
                    "href": "https://api.spotify.com/v1/artists/3jOstUTkEu2JkjvRdBA5Gu",
                    "id": "3jOstUTkEu2JkjvRdBA5Gu",
                    "name": "Weezer",
                    "type": "artist",
                    "uri": "spotify:artist:3jOstUTkEu2JkjvRdBA5Gu"
                }
            ],
            "available_markets": [
                "CA",
                "PR",
                "US"
            ],
            "disc_number": 1,
            "duration_ms": 334186,
            "explicit": false,
            "external_urls": {
                "spotify": "https://open.spotify.com/track/4eIDhl1HQabTd8hYjIqurJ"
            },
            "href": "https://api.spotify.com/v1/tracks/4eIDhl1HQabTd8hYjIqurJ",
            "id": "4eIDhl1HQabTd8hYjIqurJ",
            "is_local": false,
            "name": "Enter Sandman",
            "preview_url": "https://p.scdn.co/mp3-preview/d3ce70acd4043055ee456eda1eb832bcf247dbbe?cid=82a8a496c4904e3ebacd0a69657907e0",
            "track_number": 6,
            "type": "track",
            "uri": "spotify:track:4eIDhl1HQabTd8hYjIqurJ",
            "originals": [
                "3VqHuw0wFlIHcIPWkhIbdQ"
            ]
        },
        {
            "artists": [
                {
                    "external_urls": {
                        "spotify": "https://open.spotify.com/artist/6zlR5ttMfMNmwf2lecU9Cc"
                    },
                    "href": "https://api.spotify.com/v1/artists/6zlR5ttMfMNmwf2lecU9Cc",
                    "id": "6zlR5ttMfMNmwf2lecU9Cc",
                    "name": "Sam Fender",
                    "type": "artist",
                    "uri": "spotify:artist:6zlR5ttMfMNmwf2lecU9Cc"
                }
            ],
            "available_markets": [
                "CA",
                "PR",
                "US"
            ],
            "disc_number": 1,
            "duration_ms": 230493,
            "explicit": false,
            "external_urls": {
                "spotify": "https://open.spotify.com/track/1gLKSvABhSf6MuAQYF0rze"
            },
            "href": "https://api.spotify.com/v1/tracks/1gLKSvABhSf6MuAQYF0rze",
            "id": "1gLKSvABhSf6MuAQYF0rze",
            "is_local": false,
            "name": "Sad But True (Live)",
            "preview_url": "https://p.scdn.co/mp3-preview/676ed88eea65f1c7b842b580cbbe226ede366693?cid=82a8a496c4904e3ebacd0a69657907e0",
            "track_number": 7,
            "type": "track",
            "uri": "spotify:track:1gLKSvABhSf6MuAQYF0rze",
            "originals": [
                "5UaDi8KzCGJqFfVAOBfXhi"
            ]
        },
        {
            "artists": [
                {
                    "external_urls": {
                        "spotify": "https://open.spotify.com/artist/3Lg3FGwBxOGuefqekQzRUf"
                    },
                    "href": "https://api.spotify.com/v1/artists/3Lg3FGwBxOGuefqekQzRUf",
                    "id": "3Lg3FGwBxOGuefqekQzRUf",
                    "name": "Jason Isbell and the 400 Unit",
                    "type": "artist",
                    "uri": "spotify:artist:3Lg3FGwBxOGuefqekQzRUf"
                }
            ],
            "available_markets": [
                "CA",
                "PR",
                "US"
            ],
            "disc_number": 1,
            "duration_ms": 270280,
            "explicit": false,
            "external_urls": {
                "spotify": "https://open.spotify.com/track/6uSreOqMRVB5IxUJODBbEp"
            },
            "href": "https://api.spotify.com/v1/tracks/6uSreOqMRVB5IxUJODBbEp",
            "id": "6uSreOqMRVB5IxUJODBbEp",
            "is_local": false,
            "name": "Sad But True",
            "preview_url": "https://p.scdn.co/mp3-preview/b0982820353ebdd0bb3f3f19dd3c2d8698b9f644?cid=82a8a496c4904e3ebacd0a69657907e0",
            "track_number": 8,
            "type": "track",
            "uri": "spotify:track:6uSreOqMRVB5IxUJODBbEp",
            "originals": [
                "5UaDi8KzCGJqFfVAOBfXhi"
            ]
        },
        {
            "artists": [
                {
                    "external_urls": {
                        "spotify": "https://open.spotify.com/artist/4TPTW3cTwUtiihgOMSQfmy"
                    },
                    "href": "https://api.spotify.com/v1/artists/4TPTW3cTwUtiihgOMSQfmy",
                    "id": "4TPTW3cTwUtiihgOMSQfmy",
                    "name": "Mexican Institute Of Sound",
                    "type": "artist",
                    "uri": "spotify:artist:4TPTW3cTwUtiihgOMSQfmy"
                },
                {
                    "external_urls": {
                        "spotify": "https://open.spotify.com/artist/1CJIcvG0AwRBiclbftNcDp"
                    },
                    "href": "https://api.spotify.com/v1/artists/1CJIcvG0AwRBiclbftNcDp",
                    "id": "1CJIcvG0AwRBiclbftNcDp",
                    "name": "La Perla",
                    "type": "artist",
                    "uri": "spotify:artist:1CJIcvG0AwRBiclbftNcDp"
                },
                {
                    "external_urls": {
                        "spotify": "https://open.spotify.com/artist/2hejA1Dkf8v8R0koF44FvW"
                    },
                    "href": "https://api.spotify.com/v1/artists/2hejA1Dkf8v8R0koF44FvW",
                    "id": "2hejA1Dkf8v8R0koF44FvW",
                    "name": "Gera MX",
                    "type": "artist",
                    "uri": "spotify:artist:2hejA1Dkf8v8R0koF44FvW"
                },
                {
                    "external_urls": {
                        "spotify": "https://open.spotify.com/artist/2ye2Wgw4gimLv2eAKyk1NB"
                    },
                    "href": "https://api.spotify.com/v1/artists/2ye2Wgw4gimLv2eAKyk1NB",
                    "id": "2ye2Wgw4gimLv2eAKyk1NB",
                    "name": "Metallica",
                    "type": "artist",
                    "uri": "spotify:artist:2ye2Wgw4gimLv2eAKyk1NB"
                }
            ],
            "available_markets": [
                "CA",
                "PR",
                "US"
            ],
            "disc_number": 1,
            "duration_ms": 271240,
            "explicit": false,
            "external_urls": {
                "spotify": "https://open.spotify.com/track/0X2byvEma7Kf9ufrEQukOz"
            },
            "href": "https://api.spotify.com/v1/tracks/0X2byvEma7Kf9ufrEQukOz",
            "id": "0X2byvEma7Kf9ufrEQukOz",
            "is_local": false,
            "name": "Sad But True",
            "preview_url": "https://p.scdn.co/mp3-preview/ec5d1e824908623d554a9b141c57e1ce8f279075?cid=82a8a496c4904e3ebacd0a69657907e0",
            "track_number": 9,
            "type": "track",
            "uri": "spotify:track:0X2byvEma7Kf9ufrEQukOz",
            "originals": [
                "5UaDi8KzCGJqFfVAOBfXhi"
            ]
        },
        {
            "artists": [
                {
                    "external_urls": {
                        "spotify": "https://open.spotify.com/artist/2S5hlvw4CMtMGswFtfdK15"
                    },
                    "href": "https://api.spotify.com/v1/artists/2S5hlvw4CMtMGswFtfdK15",
                    "id": "2S5hlvw4CMtMGswFtfdK15",
                    "name": "Royal Blood",
                    "type": "artist",
                    "uri": "spotify:artist:2S5hlvw4CMtMGswFtfdK15"
                }
            ],
            "available_markets": [
                "CA",
                "PR",
                "US"
            ],
            "disc_number": 1,
            "duration_ms": 328813,
            "explicit": false,
            "external_urls": {
                "spotify": "https://open.spotify.com/track/4QAVGDeSoi3lUWdbx2bLdS"
            },
            "href": "https://api.spotify.com/v1/tracks/4QAVGDeSoi3lUWdbx2bLdS",
            "id": "4QAVGDeSoi3lUWdbx2bLdS",
            "is_local": false,
            "name": "Sad But True",
            "preview_url": "https://p.scdn.co/mp3-preview/940e5ab4cb32f65c3e658c01322c1546fa533611?cid=82a8a496c4904e3ebacd0a69657907e0",
            "track_number": 10,
            "type": "track",
            "uri": "spotify:track:4QAVGDeSoi3lUWdbx2bLdS",
            "originals": [
                "5UaDi8KzCGJqFfVAOBfXhi"
            ]
        },
        {
            "artists": [
                {
                    "external_urls": {
                        "spotify": "https://open.spotify.com/artist/7bcbShaqKdcyjnmv4Ix8j6"
                    },
                    "href": "https://api.spotify.com/v1/artists/7bcbShaqKdcyjnmv4Ix8j6",
                    "id": "7bcbShaqKdcyjnmv4Ix8j6",
                    "name": "St. Vincent",
                    "type": "artist",
                    "uri": "spotify:artist:7bcbShaqKdcyjnmv4Ix8j6"
                }
            ],
            "available_markets": [
                "CA",
                "PR",
                "US"
            ],
            "disc_number": 1,
            "duration_ms": 252453,
            "explicit": false,
            "external_urls": {
                "spotify": "https://open.spotify.com/track/1WRFfvx0V7tumOSV6Nl9z8"
            },
            "href": "https://api.spotify.com/v1/tracks/1WRFfvx0V7tumOSV6Nl9z8",
            "id": "1WRFfvx0V7tumOSV6Nl9z8",
            "is_local": false,
            "name": "Sad But True",
            "preview_url": "https://p.scdn.co/mp3-preview/593e1512db1c2b5a4961a6ec3e6f27a454dc55ee?cid=82a8a496c4904e3ebacd0a69657907e0",
            "track_number": 11,
            "type": "track",
            "uri": "spotify:track:1WRFfvx0V7tumOSV6Nl9z8",
            "originals": [
                "5UaDi8KzCGJqFfVAOBfXhi"
            ]
        },
        {
            "artists": [
                {
                    "external_urls": {
                        "spotify": "https://open.spotify.com/artist/75klPfIVnyYcyEGaicRUSF"
                    },
                    "href": "https://api.spotify.com/v1/artists/75klPfIVnyYcyEGaicRUSF",
                    "id": "75klPfIVnyYcyEGaicRUSF",
                    "name": "White Reaper",
                    "type": "artist",
                    "uri": "spotify:artist:75klPfIVnyYcyEGaicRUSF"
                }
            ],
            "available_markets": [
                "CA",
                "PR",
                "US"
            ],
            "disc_number": 1,
            "duration_ms": 322706,
            "explicit": false,
            "external_urls": {
                "spotify": "https://open.spotify.com/track/7bPIgBDoWAfkgopUT5td67"
            },
            "href": "https://api.spotify.com/v1/tracks/7bPIgBDoWAfkgopUT5td67",
            "id": "7bPIgBDoWAfkgopUT5td67",
            "is_local": false,
            "name": "Sad But True",
            "preview_url": "https://p.scdn.co/mp3-preview/f6b9d9fd12e83d6ebc1cc7163d69f6596c3c5217?cid=82a8a496c4904e3ebacd0a69657907e0",
            "track_number": 12,
            "type": "track",
            "uri": "spotify:track:7bPIgBDoWAfkgopUT5td67",
            "originals": [
                "5UaDi8KzCGJqFfVAOBfXhi"
            ]
        },
        {
            "artists": [
                {
                    "external_urls": {
                        "spotify": "https://open.spotify.com/artist/1rpgxJZxZMLnFNc1Jmyov5"
                    },
                    "href": "https://api.spotify.com/v1/artists/1rpgxJZxZMLnFNc1Jmyov5",
                    "id": "1rpgxJZxZMLnFNc1Jmyov5",
                    "name": "YB",
                    "type": "artist",
                    "uri": "spotify:artist:1rpgxJZxZMLnFNc1Jmyov5"
                }
            ],
            "available_markets": [
                "CA",
                "PR",
                "US"
            ],
            "disc_number": 1,
            "duration_ms": 243386,
            "explicit": false,
            "external_urls": {
                "spotify": "https://open.spotify.com/track/73ojnHIAxQ8QcNaMrsAjLn"
            },
            "href": "https://api.spotify.com/v1/tracks/73ojnHIAxQ8QcNaMrsAjLn",
            "id": "73ojnHIAxQ8QcNaMrsAjLn",
            "is_local": false,
            "name": "Sad But True",
            "preview_url": "https://p.scdn.co/mp3-preview/b8d2c03301edde651f766a6bf06492ac87dcf283?cid=82a8a496c4904e3ebacd0a69657907e0",
            "track_number": 13,
            "type": "track",
            "uri": "spotify:track:73ojnHIAxQ8QcNaMrsAjLn",
            "originals": [
                "5UaDi8KzCGJqFfVAOBfXhi"
            ]
        },
        {
            "artists": [
                {
                    "external_urls": {
                        "spotify": "https://open.spotify.com/artist/1km0R7wy712AzLkA1WjKET"
                    },
                    "href": "https://api.spotify.com/v1/artists/1km0R7wy712AzLkA1WjKET",
                    "id": "1km0R7wy712AzLkA1WjKET",
                    "name": "Biffy Clyro",
                    "type": "artist",
                    "uri": "spotify:artist:1km0R7wy712AzLkA1WjKET"
                }
            ],
            "available_markets": [
                "CA",
                "PR",
                "US"
            ],
            "disc_number": 2,
            "duration_ms": 309786,
            "explicit": false,
            "external_urls": {
                "spotify": "https://open.spotify.com/track/5yPT2KezufnUDzSX6RmXz8"
            },
            "href": "https://api.spotify.com/v1/tracks/5yPT2KezufnUDzSX6RmXz8",
            "id": "5yPT2KezufnUDzSX6RmXz8",
            "is_local": false,
            "name": "Holier Than Thou",
            "preview_url": "https://p.scdn.co/mp3-preview/5e268097b04b91eeda497f6bd3f9d6341ac00f06?cid=82a8a496c4904e3ebacd0a69657907e0",
            "track_number": 1,
            "type": "track",
            "uri": "spotify:track:5yPT2KezufnUDzSX6RmXz8",
            "originals": [
                "5VJ05rDJ2O4cECGNbWPi64"
            ]
        },
        {
            "artists": [
                {
                    "external_urls": {
                        "spotify": "https://open.spotify.com/artist/1aQ7P3HtKOQFW16ebjiks1"
                    },
                    "href": "https://api.spotify.com/v1/artists/1aQ7P3HtKOQFW16ebjiks1",
                    "id": "1aQ7P3HtKOQFW16ebjiks1",
                    "name": "The Chats",
                    "type": "artist",
                    "uri": "spotify:artist:1aQ7P3HtKOQFW16ebjiks1"
                }
            ],
            "available_markets": [
                "CA",
                "PR",
                "US"
            ],
            "disc_number": 2,
            "duration_ms": 145680,
            "explicit": false,
            "external_urls": {
                "spotify": "https://open.spotify.com/track/221Sh9QWN2DStm0EjVFqE9"
            },
            "href": "https://api.spotify.com/v1/tracks/221Sh9QWN2DStm0EjVFqE9",
            "id": "221Sh9QWN2DStm0EjVFqE9",
            "is_local": false,
            "name": "Holier Than Thou",
            "preview_url": "https://p.scdn.co/mp3-preview/4f3c27e7dd26f24f6135b84a12dff18fd1683af9?cid=82a8a496c4904e3ebacd0a69657907e0",
            "track_number": 2,
            "type": "track",
            "uri": "spotify:track:221Sh9QWN2DStm0EjVFqE9",
            "originals": [
                "5VJ05rDJ2O4cECGNbWPi64"
            ]
        },
        {
            "artists": [
                {
                    "external_urls": {
                        "spotify": "https://open.spotify.com/artist/4fY9hRf8gHMOszNWFhR1wB"
                    },
                    "href": "https://api.spotify.com/v1/artists/4fY9hRf8gHMOszNWFhR1wB",
                    "id": "4fY9hRf8gHMOszNWFhR1wB",
                    "name": "OFF!",
                    "type": "artist",
                    "uri": "spotify:artist:4fY9hRf8gHMOszNWFhR1wB"
                }
            ],
            "available_markets": [
                "CA",
                "PR",
                "US"
            ],
            "disc_number": 2,
            "duration_ms": 183973,
            "explicit": false,
            "external_urls": {
                "spotify": "https://open.spotify.com/track/3nvacNi1HXrrnhVNCV4xfC"
            },
            "href": "https://api.spotify.com/v1/tracks/3nvacNi1HXrrnhVNCV4xfC",
            "id": "3nvacNi1HXrrnhVNCV4xfC",
            "is_local": false,
            "name": "Holier Than Thou",
            "preview_url": "https://p.scdn.co/mp3-preview/af8327d4bc2700c10520d226e94bd276707fb5cf?cid=82a8a496c4904e3ebacd0a69657907e0",
            "track_number": 3,
            "type": "track",
            "uri": "spotify:track:3nvacNi1HXrrnhVNCV4xfC",
            "originals": [
                "5VJ05rDJ2O4cECGNbWPi64"
            ]
        },
        {
            "artists": [
                {
                    "external_urls": {
                        "spotify": "https://open.spotify.com/artist/6A7uqgC2N1nUhrCLAytHxN"
                    },
                    "href": "https://api.spotify.com/v1/artists/6A7uqgC2N1nUhrCLAytHxN",
                    "id": "6A7uqgC2N1nUhrCLAytHxN",
                    "name": "PUP",
                    "type": "artist",
                    "uri": "spotify:artist:6A7uqgC2N1nUhrCLAytHxN"
                }
            ],
            "available_markets": [
                "CA",
                "PR",
                "US"
            ],
            "disc_number": 2,
            "duration_ms": 235933,
            "explicit": false,
            "external_urls": {
                "spotify": "https://open.spotify.com/track/0k30xe1ye3cRQxMxjy9ig1"
            },
            "href": "https://api.spotify.com/v1/tracks/0k30xe1ye3cRQxMxjy9ig1",
            "id": "0k30xe1ye3cRQxMxjy9ig1",
            "is_local": false,
            "name": "Holier Than Thou",
            "preview_url": "https://p.scdn.co/mp3-preview/7073a9fb765be8e311cf3c1a4135c752b029645f?cid=82a8a496c4904e3ebacd0a69657907e0",
            "track_number": 4,
            "type": "track",
            "uri": "spotify:track:0k30xe1ye3cRQxMxjy9ig1",
            "originals": [
                "5VJ05rDJ2O4cECGNbWPi64"
            ]
        },
        {
            "artists": [
                {
                    "external_urls": {
                        "spotify": "https://open.spotify.com/artist/0nhDd1RWjZ6SDV1Vg1Ku2Q"
                    },
                    "href": "https://api.spotify.com/v1/artists/0nhDd1RWjZ6SDV1Vg1Ku2Q",
                    "id": "0nhDd1RWjZ6SDV1Vg1Ku2Q",
                    "name": "Corey Taylor",
                    "type": "artist",
                    "uri": "spotify:artist:0nhDd1RWjZ6SDV1Vg1Ku2Q"
                }
            ],
            "available_markets": [
                "CA",
                "PR",
                "US"
            ],
            "disc_number": 2,
            "duration_ms": 250600,
            "explicit": false,
            "external_urls": {
                "spotify": "https://open.spotify.com/track/4Lq6sbm637rEeMCobIgp1h"
            },
            "href": "https://api.spotify.com/v1/tracks/4Lq6sbm637rEeMCobIgp1h",
            "id": "4Lq6sbm637rEeMCobIgp1h",
            "is_local": false,
            "name": "Holier Than Thou",
            "preview_url": "https://p.scdn.co/mp3-preview/326f46add9e64d272d57c539189319ae7cf27438?cid=82a8a496c4904e3ebacd0a69657907e0",
            "track_number": 5,
            "type": "track",
            "uri": "spotify:track:4Lq6sbm637rEeMCobIgp1h",
            "originals": [
                "5VJ05rDJ2O4cECGNbWPi64"
            ]
        },
        {
            "artists": [
                {
                    "external_urls": {
                        "spotify": "https://open.spotify.com/artist/26T3LtbuGT1Fu9m0eRq5X3"
                    },
                    "href": "https://api.spotify.com/v1/artists/26T3LtbuGT1Fu9m0eRq5X3",
                    "id": "26T3LtbuGT1Fu9m0eRq5X3",
                    "name": "Cage The Elephant",
                    "type": "artist",
                    "uri": "spotify:artist:26T3LtbuGT1Fu9m0eRq5X3"
                }
            ],
            "available_markets": [
                "CA",
                "PR",
                "US"
            ],
            "disc_number": 2,
            "duration_ms": 353560,
            "explicit": false,
            "external_urls": {
                "spotify": "https://open.spotify.com/track/1SC2ebuMgVo5eKucWM8N8C"
            },
            "href": "https://api.spotify.com/v1/tracks/1SC2ebuMgVo5eKucWM8N8C",
            "id": "1SC2ebuMgVo5eKucWM8N8C",
            "is_local": false,
            "name": "The Unforgiven",
            "preview_url": "https://p.scdn.co/mp3-preview/7cedbfc470e5fb87444c88ee4100cd02a9b301a4?cid=82a8a496c4904e3ebacd0a69657907e0",
            "track_number": 6,
            "type": "track",
            "uri": "spotify:track:1SC2ebuMgVo5eKucWM8N8C",
            "originals": [
                "7lwvxYumAEo10lzAplRGXM"
            ]
        },
        {
            "artists": [
                {
                    "external_urls": {
                        "spotify": "https://open.spotify.com/artist/6CXEwIaXYfVJ84biCxqc9k"
                    },
                    "href": "https://api.spotify.com/v1/artists/6CXEwIaXYfVJ84biCxqc9k",
                    "id": "6CXEwIaXYfVJ84biCxqc9k",
                    "name": "Vishal Dadlani",
                    "type": "artist",
                    "uri": "spotify:artist:6CXEwIaXYfVJ84biCxqc9k"
                },
                {
                    "external_urls": {
                        "spotify": "https://open.spotify.com/artist/4Ai0pGz6GhQavjzaRhPTvz"
                    },
                    "href": "https://api.spotify.com/v1/artists/4Ai0pGz6GhQavjzaRhPTvz",
                    "id": "4Ai0pGz6GhQavjzaRhPTvz",
                    "name": "DIVINE",
                    "type": "artist",
                    "uri": "spotify:artist:4Ai0pGz6GhQavjzaRhPTvz"
                },
                {
                    "external_urls": {
                        "spotify": "https://open.spotify.com/artist/58Wsx9FbcjSM8a6kzLf03W"
                    },
                    "href": "https://api.spotify.com/v1/artists/58Wsx9FbcjSM8a6kzLf03W",
                    "id": "58Wsx9FbcjSM8a6kzLf03W",
                    "name": "Shor Police",
                    "type": "artist",
                    "uri": "spotify:artist:58Wsx9FbcjSM8a6kzLf03W"
                },
                {
                    "external_urls": {
                        "spotify": "https://open.spotify.com/artist/2ye2Wgw4gimLv2eAKyk1NB"
                    },
                    "href": "https://api.spotify.com/v1/artists/2ye2Wgw4gimLv2eAKyk1NB",
                    "id": "2ye2Wgw4gimLv2eAKyk1NB",
                    "name": "Metallica",
                    "type": "artist",
                    "uri": "spotify:artist:2ye2Wgw4gimLv2eAKyk1NB"
                }
            ],
            "available_markets": [
                "CA",
                "PR",
                "US"
            ],
            "disc_number": 2,
            "duration_ms": 260773,
            "explicit": false,
            "external_urls": {
                "spotify": "https://open.spotify.com/track/1VsUixRmdRKDplKyuIvfmO"
            },
            "href": "https://api.spotify.com/v1/tracks/1VsUixRmdRKDplKyuIvfmO",
            "id": "1VsUixRmdRKDplKyuIvfmO",
            "is_local": false,
            "name": "The Unforgiven",
            "preview_url": "https://p.scdn.co/mp3-preview/62c0e823410c284cba32e63b15803c5669e92378?cid=82a8a496c4904e3ebacd0a69657907e0",
            "track_number": 7,
            "type": "track",
            "uri": "spotify:track:1VsUixRmdRKDplKyuIvfmO",
            "originals": [
                "7lwvxYumAEo10lzAplRGXM"
            ]
        },
        {
            "artists": [
                {
                    "external_urls": {
                        "spotify": "https://open.spotify.com/artist/6ommlbuccgdiKSgjvVlQ4W"
                    },
                    "href": "https://api.spotify.com/v1/artists/6ommlbuccgdiKSgjvVlQ4W",
                    "id": "6ommlbuccgdiKSgjvVlQ4W",
                    "name": "Diet Cig",
                    "type": "artist",
                    "uri": "spotify:artist:6ommlbuccgdiKSgjvVlQ4W"
                }
            ],
            "available_markets": [
                "CA",
                "PR",
                "US"
            ],
            "disc_number": 2,
            "duration_ms": 287320,
            "explicit": false,
            "external_urls": {
                "spotify": "https://open.spotify.com/track/19auTdK7aLiRRIU6dicuvV"
            },
            "href": "https://api.spotify.com/v1/tracks/19auTdK7aLiRRIU6dicuvV",
            "id": "19auTdK7aLiRRIU6dicuvV",
            "is_local": false,
            "name": "The Unforgiven",
            "preview_url": "https://p.scdn.co/mp3-preview/fdfa51eb9dc849667f4d211d08a8f7a797ce9a49?cid=82a8a496c4904e3ebacd0a69657907e0",
            "track_number": 8,
            "type": "track",
            "uri": "spotify:track:19auTdK7aLiRRIU6dicuvV",
            "originals": [
                "7lwvxYumAEo10lzAplRGXM"
            ]
        },
        {
            "artists": [
                {
                    "external_urls": {
                        "spotify": "https://open.spotify.com/artist/1dqGS5sT6PE2wEvP1gROZC"
                    },
                    "href": "https://api.spotify.com/v1/artists/1dqGS5sT6PE2wEvP1gROZC",
                    "id": "1dqGS5sT6PE2wEvP1gROZC",
                    "name": "Flatbush Zombies",
                    "type": "artist",
                    "uri": "spotify:artist:1dqGS5sT6PE2wEvP1gROZC"
                },
                {
                    "external_urls": {
                        "spotify": "https://open.spotify.com/artist/4vBBOm1tR7WToK4DZmDZAd"
                    },
                    "href": "https://api.spotify.com/v1/artists/4vBBOm1tR7WToK4DZmDZAd",
                    "id": "4vBBOm1tR7WToK4DZmDZAd",
                    "name": "DJ Scratch",
                    "type": "artist",
                    "uri": "spotify:artist:4vBBOm1tR7WToK4DZmDZAd"
                },
                {
                    "external_urls": {
                        "spotify": "https://open.spotify.com/artist/2ye2Wgw4gimLv2eAKyk1NB"
                    },
                    "href": "https://api.spotify.com/v1/artists/2ye2Wgw4gimLv2eAKyk1NB",
                    "id": "2ye2Wgw4gimLv2eAKyk1NB",
                    "name": "Metallica",
                    "type": "artist",
                    "uri": "spotify:artist:2ye2Wgw4gimLv2eAKyk1NB"
                }
            ],
            "available_markets": [
                "CA",
                "PR",
                "US"
            ],
            "disc_number": 2,
            "duration_ms": 276733,
            "explicit": false,
            "external_urls": {
                "spotify": "https://open.spotify.com/track/1at8S4W63ZoRQDLKdMSfxG"
            },
            "href": "https://api.spotify.com/v1/tracks/1at8S4W63ZoRQDLKdMSfxG",
            "id": "1at8S4W63ZoRQDLKdMSfxG",
            "is_local": false,
            "name": "The Unforgiven",
            "preview_url": "https://p.scdn.co/mp3-preview/f2f372804fb52669c64e460783ee0eddc38bc0ef?cid=82a8a496c4904e3ebacd0a69657907e0",
            "track_number": 9,
            "type": "track",
            "uri": "spotify:track:1at8S4W63ZoRQDLKdMSfxG",
            "originals": [
                "7lwvxYumAEo10lzAplRGXM"
            ]
        },
        {
            "artists": [
                {
                    "external_urls": {
                        "spotify": "https://open.spotify.com/artist/5xd2Tg7Zo8755eCy8Gxkp8"
                    },
                    "href": "https://api.spotify.com/v1/artists/5xd2Tg7Zo8755eCy8Gxkp8",
                    "id": "5xd2Tg7Zo8755eCy8Gxkp8",
                    "name": "Ha*Ash",
                    "type": "artist",
                    "uri": "spotify:artist:5xd2Tg7Zo8755eCy8Gxkp8"
                }
            ],
            "available_markets": [
                "CA",
                "PR",
                "US"
            ],
            "disc_number": 2,
            "duration_ms": 245866,
            "explicit": false,
            "external_urls": {
                "spotify": "https://open.spotify.com/track/1i0p8KzD1PJauIG9OOzf5H"
            },
            "href": "https://api.spotify.com/v1/tracks/1i0p8KzD1PJauIG9OOzf5H",
            "id": "1i0p8KzD1PJauIG9OOzf5H",
            "is_local": false,
            "name": "The Unforgiven",
            "preview_url": "https://p.scdn.co/mp3-preview/24c3c332169c1802e6e1e9db1808de30a82e1397?cid=82a8a496c4904e3ebacd0a69657907e0",
            "track_number": 10,
            "type": "track",
            "uri": "spotify:track:1i0p8KzD1PJauIG9OOzf5H",
            "originals": [
                "7lwvxYumAEo10lzAplRGXM"
            ]
        },
        {
            "artists": [
                {
                    "external_urls": {
                        "spotify": "https://open.spotify.com/artist/62nVRNDLaS8m1p31F6omGw"
                    },
                    "href": "https://api.spotify.com/v1/artists/62nVRNDLaS8m1p31F6omGw",
                    "id": "62nVRNDLaS8m1p31F6omGw",
                    "name": "Jos\u00e9 Madero",
                    "type": "artist",
                    "uri": "spotify:artist:62nVRNDLaS8m1p31F6omGw"
                }
            ],
            "available_markets": [
                "CA",
                "PR",
                "US"
            ],
            "disc_number": 2,
            "duration_ms": 240906,
            "explicit": false,
            "external_urls": {
                "spotify": "https://open.spotify.com/track/0En9y2PB2ZhR0db5gt3QXA"
            },
            "href": "https://api.spotify.com/v1/tracks/0En9y2PB2ZhR0db5gt3QXA",
            "id": "0En9y2PB2ZhR0db5gt3QXA",
            "is_local": false,
            "name": "The Unforgiven",
            "preview_url": "https://p.scdn.co/mp3-preview/49070c87adb253eda6717a71c5dcfd488a8bc189?cid=82a8a496c4904e3ebacd0a69657907e0",
            "track_number": 11,
            "type": "track",
            "uri": "spotify:track:0En9y2PB2ZhR0db5gt3QXA",
            "originals": [
                "7lwvxYumAEo10lzAplRGXM"
            ]
        },
        {
            "artists": [
                {
                    "external_urls": {
                        "spotify": "https://open.spotify.com/artist/5W10uJRsbt9bROJDKoI1Wn"
                    },
                    "href": "https://api.spotify.com/v1/artists/5W10uJRsbt9bROJDKoI1Wn",
                    "id": "5W10uJRsbt9bROJDKoI1Wn",
                    "name": "Moses Sumney",
                    "type": "artist",
                    "uri": "spotify:artist:5W10uJRsbt9bROJDKoI1Wn"
                }
            ],
            "available_markets": [
                "CA",
                "PR",
                "US"
            ],
            "disc_number": 2,
            "duration_ms": 333493,
            "explicit": false,
            "external_urls": {
                "spotify": "https://open.spotify.com/track/79xJV2izkHAsroRgIzId3Z"
            },
            "href": "https://api.spotify.com/v1/tracks/79xJV2izkHAsroRgIzId3Z",
            "id": "79xJV2izkHAsroRgIzId3Z",
            "is_local": false,
            "name": "The Unforgiven",
            "preview_url": "https://p.scdn.co/mp3-preview/a6ce5bba81c08805609f7993112f90af3152235c?cid=82a8a496c4904e3ebacd0a69657907e0",
            "track_number": 12,
            "type": "track",
            "uri": "spotify:track:79xJV2izkHAsroRgIzId3Z",
            "originals": [
                "7lwvxYumAEo10lzAplRGXM"
            ]
        },
        {
            "artists": [
                {
                    "external_urls": {
                        "spotify": "https://open.spotify.com/artist/1vyhD5VmyZ7KMfW5gqLgo5"
                    },
                    "href": "https://api.spotify.com/v1/artists/1vyhD5VmyZ7KMfW5gqLgo5",
                    "id": "1vyhD5VmyZ7KMfW5gqLgo5",
                    "name": "J Balvin",
                    "type": "artist",
                    "uri": "spotify:artist:1vyhD5VmyZ7KMfW5gqLgo5"
                },
                {
                    "external_urls": {
                        "spotify": "https://open.spotify.com/artist/2ye2Wgw4gimLv2eAKyk1NB"
                    },
                    "href": "https://api.spotify.com/v1/artists/2ye2Wgw4gimLv2eAKyk1NB",
                    "id": "2ye2Wgw4gimLv2eAKyk1NB",
                    "name": "Metallica",
                    "type": "artist",
                    "uri": "spotify:artist:2ye2Wgw4gimLv2eAKyk1NB"
                }
            ],
            "available_markets": [
                "CA",
                "PR",
                "US"
            ],
            "disc_number": 3,
            "duration_ms": 158573,
            "explicit": false,
            "external_urls": {
                "spotify": "https://open.spotify.com/track/7vlZHBqon11tZl8b53WsJC"
            },
            "href": "https://api.spotify.com/v1/tracks/7vlZHBqon11tZl8b53WsJC",
            "id": "7vlZHBqon11tZl8b53WsJC",
            "is_local": false,
            "name": "Wherever I May Roam",
            "preview_url": "https://p.scdn.co/mp3-preview/82d57480f4035ec86656745102519a4e93192eb7?cid=82a8a496c4904e3ebacd0a69657907e0",
            "track_number": 1,
            "type": "track",
            "uri": "spotify:track:7vlZHBqon11tZl8b53WsJC",
            "originals": [
                "745sNpjWbAxo2MA2zSYbyD"
            ]
        },
        {
            "artists": [
                {
                    "external_urls": {
                        "spotify": "https://open.spotify.com/artist/3jNkaOXasoc7RsxdchvEVq"
                    },
                    "href": "https://api.spotify.com/v1/artists/3jNkaOXasoc7RsxdchvEVq",
                    "id": "3jNkaOXasoc7RsxdchvEVq",
                    "name": "Chase & Status",
                    "type": "artist",
                    "uri": "spotify:artist:3jNkaOXasoc7RsxdchvEVq"
                },
                {
                    "external_urls": {
                        "spotify": "https://open.spotify.com/artist/51op6E2hjkeutwFhgw32mL"
                    },
                    "href": "https://api.spotify.com/v1/artists/51op6E2hjkeutwFhgw32mL",
                    "id": "51op6E2hjkeutwFhgw32mL",
                    "name": "BackRoad Gee",
                    "type": "artist",
                    "uri": "spotify:artist:51op6E2hjkeutwFhgw32mL"
                },
                {
                    "external_urls": {
                        "spotify": "https://open.spotify.com/artist/2ye2Wgw4gimLv2eAKyk1NB"
                    },
                    "href": "https://api.spotify.com/v1/artists/2ye2Wgw4gimLv2eAKyk1NB",
                    "id": "2ye2Wgw4gimLv2eAKyk1NB",
                    "name": "Metallica",
                    "type": "artist",
                    "uri": "spotify:artist:2ye2Wgw4gimLv2eAKyk1NB"
                }
            ],
            "available_markets": [
                "CA",
                "PR",
                "US"
            ],
            "disc_number": 3,
            "duration_ms": 186560,
            "explicit": false,
            "external_urls": {
                "spotify": "https://open.spotify.com/track/7jJcG95Pyqjg0KqSlSzbzi"
            },
            "href": "https://api.spotify.com/v1/tracks/7jJcG95Pyqjg0KqSlSzbzi",
            "id": "7jJcG95Pyqjg0KqSlSzbzi",
            "is_local": false,
            "name": "Wherever I May Roam",
            "preview_url": "https://p.scdn.co/mp3-preview/6ff83690df1f93c19a9a049b53c58aa4eac7c098?cid=82a8a496c4904e3ebacd0a69657907e0",
            "track_number": 2,
            "type": "track",
            "uri": "spotify:track:7jJcG95Pyqjg0KqSlSzbzi",
            "originals": [
                "745sNpjWbAxo2MA2zSYbyD"
            ]
        },
        {
            "artists": [
                {
                    "external_urls": {
                        "spotify": "https://open.spotify.com/artist/0KuF7reCTOZwV7YJnHQqgr"
                    },
                    "href": "https://api.spotify.com/v1/artists/0KuF7reCTOZwV7YJnHQqgr",
                    "id": "0KuF7reCTOZwV7YJnHQqgr",
                    "name": "The Neptunes",
                    "type": "artist",
                    "uri": "spotify:artist:0KuF7reCTOZwV7YJnHQqgr"
                },
                {
                    "external_urls": {
                        "spotify": "https://open.spotify.com/artist/2ye2Wgw4gimLv2eAKyk1NB"
                    },
                    "href": "https://api.spotify.com/v1/artists/2ye2Wgw4gimLv2eAKyk1NB",
                    "id": "2ye2Wgw4gimLv2eAKyk1NB",
                    "name": "Metallica",
                    "type": "artist",
                    "uri": "spotify:artist:2ye2Wgw4gimLv2eAKyk1NB"
                }
            ],
            "available_markets": [
                "CA",
                "PR",
                "US"
            ],
            "disc_number": 3,
            "duration_ms": 236800,
            "explicit": false,
            "external_urls": {
                "spotify": "https://open.spotify.com/track/6HgbjvftXgmDgaRVxGzDqE"
            },
            "href": "https://api.spotify.com/v1/tracks/6HgbjvftXgmDgaRVxGzDqE",
            "id": "6HgbjvftXgmDgaRVxGzDqE",
            "is_local": false,
            "name": "Wherever I May Roam",
            "preview_url": "https://p.scdn.co/mp3-preview/fa85fdad79a3445e3e1b8f66824978f6d08a7ee6?cid=82a8a496c4904e3ebacd0a69657907e0",
            "track_number": 3,
            "type": "track",
            "uri": "spotify:track:6HgbjvftXgmDgaRVxGzDqE",
            "originals": [
                "745sNpjWbAxo2MA2zSYbyD"
            ]
        },
        {
            "artists": [
                {
                    "external_urls": {
                        "spotify": "https://open.spotify.com/artist/4MoAOfV4ROWofLG3a3hhBN"
                    },
                    "href": "https://api.spotify.com/v1/artists/4MoAOfV4ROWofLG3a3hhBN",
                    "id": "4MoAOfV4ROWofLG3a3hhBN",
                    "name": "Jon Pardi",
                    "type": "artist",
                    "uri": "spotify:artist:4MoAOfV4ROWofLG3a3hhBN"
                }
            ],
            "available_markets": [
                "CA",
                "PR",
                "US"
            ],
            "disc_number": 3,
            "duration_ms": 404880,
            "explicit": false,
            "external_urls": {
                "spotify": "https://open.spotify.com/track/4YgXImTc7KhO4bL4i2optD"
            },
            "href": "https://api.spotify.com/v1/tracks/4YgXImTc7KhO4bL4i2optD",
            "id": "4YgXImTc7KhO4bL4i2optD",
            "is_local": false,
            "name": "Wherever I May Roam",
            "preview_url": "https://p.scdn.co/mp3-preview/5e57d03e48501691901595a2fce1f75a821d0fda?cid=82a8a496c4904e3ebacd0a69657907e0",
            "track_number": 4,
            "type": "track",
            "uri": "spotify:track:4YgXImTc7KhO4bL4i2optD",
            "originals": [
                "745sNpjWbAxo2MA2zSYbyD"
            ]
        },
        {
            "artists": [
                {
                    "external_urls": {
                        "spotify": "https://open.spotify.com/artist/5tOWIviwLM1EIqGAbF8VSU"
                    },
                    "href": "https://api.spotify.com/v1/artists/5tOWIviwLM1EIqGAbF8VSU",
                    "id": "5tOWIviwLM1EIqGAbF8VSU",
                    "name": "SebastiAn",
                    "type": "artist",
                    "uri": "spotify:artist:5tOWIviwLM1EIqGAbF8VSU"
                },
                {
                    "external_urls": {
                        "spotify": "https://open.spotify.com/artist/2ye2Wgw4gimLv2eAKyk1NB"
                    },
                    "href": "https://api.spotify.com/v1/artists/2ye2Wgw4gimLv2eAKyk1NB",
                    "id": "2ye2Wgw4gimLv2eAKyk1NB",
                    "name": "Metallica",
                    "type": "artist",
                    "uri": "spotify:artist:2ye2Wgw4gimLv2eAKyk1NB"
                }
            ],
            "available_markets": [
                "CA",
                "PR",
                "US"
            ],
            "disc_number": 3,
            "duration_ms": 354440,
            "explicit": false,
            "external_urls": {
                "spotify": "https://open.spotify.com/track/6m1aaREcawdnkIVzYj1fZF"
            },
            "href": "https://api.spotify.com/v1/tracks/6m1aaREcawdnkIVzYj1fZF",
            "id": "6m1aaREcawdnkIVzYj1fZF",
            "is_local": false,
            "name": "Don't Tread on Else Matters",
            "preview_url": "https://p.scdn.co/mp3-preview/2d1c26038c66477297c71f6c16185deaa454e586?cid=82a8a496c4904e3ebacd0a69657907e0",
            "track_number": 5,
            "type": "track",
            "uri": "spotify:track:6m1aaREcawdnkIVzYj1fZF",
            "originals": [
                "0u9ORuO4xOQY5SHxNcvCnV",
                "2CtemffYhT0DJWcT1XW047"
            ]
        },
        {
            "artists": [
                {
                    "external_urls": {
                        "spotify": "https://open.spotify.com/artist/4kI8Ie27vjvonwaB2ePh8T"
                    },
                    "href": "https://api.spotify.com/v1/artists/4kI8Ie27vjvonwaB2ePh8T",
                    "id": "4kI8Ie27vjvonwaB2ePh8T",
                    "name": "Portugal. The Man",
                    "type": "artist",
                    "uri": "spotify:artist:4kI8Ie27vjvonwaB2ePh8T"
                },
                {
                    "external_urls": {
                        "spotify": "https://open.spotify.com/artist/3jD4LaXdTKzJJuarvH62mj"
                    },
                    "href": "https://api.spotify.com/v1/artists/3jD4LaXdTKzJJuarvH62mj",
                    "id": "3jD4LaXdTKzJJuarvH62mj",
                    "name": "Aaron Beam",
                    "type": "artist",
                    "uri": "spotify:artist:3jD4LaXdTKzJJuarvH62mj"
                }
            ],
            "available_markets": [
                "CA",
                "PR",
                "US"
            ],
            "disc_number": 3,
            "duration_ms": 254453,
            "explicit": false,
            "external_urls": {
                "spotify": "https://open.spotify.com/track/1J7WMfkkhgEtFjwtmwo44s"
            },
            "href": "https://api.spotify.com/v1/tracks/1J7WMfkkhgEtFjwtmwo44s",
            "id": "1J7WMfkkhgEtFjwtmwo44s",
            "is_local": false,
            "name": "Don't Tread on Me",
            "preview_url": "https://p.scdn.co/mp3-preview/d2300e15d15599c8fb3b6b63cd0d2ba11a548362?cid=82a8a496c4904e3ebacd0a69657907e0",
            "track_number": 6,
            "type": "track",
            "uri": "spotify:track:1J7WMfkkhgEtFjwtmwo44s",
            "originals": [
                "0u9ORuO4xOQY5SHxNcvCnV"
            ]
        },
        {
            "artists": [
                {
                    "external_urls": {
                        "spotify": "https://open.spotify.com/artist/0L5fC7Ogm2YwgqVCRcF1bT"
                    },
                    "href": "https://api.spotify.com/v1/artists/0L5fC7Ogm2YwgqVCRcF1bT",
                    "id": "0L5fC7Ogm2YwgqVCRcF1bT",
                    "name": "Volbeat",
                    "type": "artist",
                    "uri": "spotify:artist:0L5fC7Ogm2YwgqVCRcF1bT"
                }
            ],
            "available_markets": [
                "CA",
                "PR",
                "US"
            ],
            "disc_number": 3,
            "duration_ms": 218640,
            "explicit": false,
            "external_urls": {
                "spotify": "https://open.spotify.com/track/1yBt22Yr0zA21CiXXTXAnT"
            },
            "href": "https://api.spotify.com/v1/tracks/1yBt22Yr0zA21CiXXTXAnT",
            "id": "1yBt22Yr0zA21CiXXTXAnT",
            "is_local": false,
            "name": "Don't Tread on Me",
            "preview_url": "https://p.scdn.co/mp3-preview/e65a23bae9aeb19a79b544efd6289f6ff04795f3?cid=82a8a496c4904e3ebacd0a69657907e0",
            "track_number": 7,
            "type": "track",
            "uri": "spotify:track:1yBt22Yr0zA21CiXXTXAnT",
            "originals": [
                "0u9ORuO4xOQY5SHxNcvCnV"
            ]
        },
        {
            "artists": [
                {
                    "external_urls": {
                        "spotify": "https://open.spotify.com/artist/0b2B3PwcYzQAhuJacmcYgc"
                    },
                    "href": "https://api.spotify.com/v1/artists/0b2B3PwcYzQAhuJacmcYgc",
                    "id": "0b2B3PwcYzQAhuJacmcYgc",
                    "name": "The HU",
                    "type": "artist",
                    "uri": "spotify:artist:0b2B3PwcYzQAhuJacmcYgc"
                }
            ],
            "available_markets": [
                "CA",
                "PR",
                "US"
            ],
            "disc_number": 3,
            "duration_ms": 246773,
            "explicit": false,
            "external_urls": {
                "spotify": "https://open.spotify.com/track/6LQJIsR9T0AoHcfzmXTVot"
            },
            "href": "https://api.spotify.com/v1/tracks/6LQJIsR9T0AoHcfzmXTVot",
            "id": "6LQJIsR9T0AoHcfzmXTVot",
            "is_local": false,
            "name": "Through the Never",
            "preview_url": "https://p.scdn.co/mp3-preview/d5ea5fe5a0a4373d734f4b6fe95881ffcadef829?cid=82a8a496c4904e3ebacd0a69657907e0",
            "track_number": 8,
            "type": "track",
            "uri": "spotify:track:6LQJIsR9T0AoHcfzmXTVot",
            "originals": [
                "0Nl9491E3l4mDUBlHhuWpD"
            ]
        },
        {
            "artists": [
                {
                    "external_urls": {
                        "spotify": "https://open.spotify.com/artist/21EqvfrgEecTOZtKffQ82k"
                    },
                    "href": "https://api.spotify.com/v1/artists/21EqvfrgEecTOZtKffQ82k",
                    "id": "21EqvfrgEecTOZtKffQ82k",
                    "name": "Tomi Ow\u00f3",
                    "type": "artist",
                    "uri": "spotify:artist:21EqvfrgEecTOZtKffQ82k"
                }
            ],
            "available_markets": [
                "CA",
                "PR",
                "US"
            ],
            "disc_number": 3,
            "duration_ms": 186080,
            "explicit": false,
            "external_urls": {
                "spotify": "https://open.spotify.com/track/46VjpGuRfjZcphJH2nVPT5"
            },
            "href": "https://api.spotify.com/v1/tracks/46VjpGuRfjZcphJH2nVPT5",
            "id": "46VjpGuRfjZcphJH2nVPT5",
            "is_local": false,
            "name": "Through the Never",
            "preview_url": "https://p.scdn.co/mp3-preview/5bbeb0bf4873a290aecff091599f6f1525da958f?cid=82a8a496c4904e3ebacd0a69657907e0",
            "track_number": 9,
            "type": "track",
            "uri": "spotify:track:46VjpGuRfjZcphJH2nVPT5",
            "originals": [
                "0Nl9491E3l4mDUBlHhuWpD"
            ]
        },
        {
            "artists": [
                {
                    "external_urls": {
                        "spotify": "https://open.spotify.com/artist/1r1uxoy19fzMxunt3ONAkG"
                    },
                    "href": "https://api.spotify.com/v1/artists/1r1uxoy19fzMxunt3ONAkG",
                    "id": "1r1uxoy19fzMxunt3ONAkG",
                    "name": "Phoebe Bridgers",
                    "type": "artist",
                    "uri": "spotify:artist:1r1uxoy19fzMxunt3ONAkG"
                }
            ],
            "available_markets": [
                "CA",
                "PR",
                "US"
            ],
            "disc_number": 3,
            "duration_ms": 274506,
            "explicit": false,
            "external_urls": {
                "spotify": "https://open.spotify.com/track/279Mz9Cv892xJxoJR3Zjx6"
            },
            "href": "https://api.spotify.com/v1/tracks/279Mz9Cv892xJxoJR3Zjx6",
            "id": "279Mz9Cv892xJxoJR3Zjx6",
            "is_local": false,
            "name": "Nothing Else Matters",
            "preview_url": "https://p.scdn.co/mp3-preview/4dddd785dbc927c3086aa4e02ec624a2280da7be?cid=82a8a496c4904e3ebacd0a69657907e0",
            "track_number": 10,
            "type": "track",
            "uri": "spotify:track:279Mz9Cv892xJxoJR3Zjx6",
            "originals": [
                "2CtemffYhT0DJWcT1XW047"
            ]
        },
        {
            "artists": [
                {
                    "external_urls": {
                        "spotify": "https://open.spotify.com/artist/5YGY8feqx7naU7z4HrwZM6"
                    },
                    "href": "https://api.spotify.com/v1/artists/5YGY8feqx7naU7z4HrwZM6",
                    "id": "5YGY8feqx7naU7z4HrwZM6",
                    "name": "Miley Cyrus",
                    "type": "artist",
                    "uri": "spotify:artist:5YGY8feqx7naU7z4HrwZM6"
                },
                {
                    "external_urls": {
                        "spotify": "https://open.spotify.com/artist/4olE3I5QU0dvSR7LIpqTXc"
                    },
                    "href": "https://api.spotify.com/v1/artists/4olE3I5QU0dvSR7LIpqTXc",
                    "id": "4olE3I5QU0dvSR7LIpqTXc",
                    "name": "WATT",
                    "type": "artist",
                    "uri": "spotify:artist:4olE3I5QU0dvSR7LIpqTXc"
                },
                {
                    "external_urls": {
                        "spotify": "https://open.spotify.com/artist/3PhoLpVuITZKcymswpck5b"
                    },
                    "href": "https://api.spotify.com/v1/artists/3PhoLpVuITZKcymswpck5b",
                    "id": "3PhoLpVuITZKcymswpck5b",
                    "name": "Elton John",
                    "type": "artist",
                    "uri": "spotify:artist:3PhoLpVuITZKcymswpck5b"
                },
                {
                    "external_urls": {
                        "spotify": "https://open.spotify.com/artist/5Dl3HXZjG6ZOWT5cV375lk"
                    },
                    "href": "https://api.spotify.com/v1/artists/5Dl3HXZjG6ZOWT5cV375lk",
                    "id": "5Dl3HXZjG6ZOWT5cV375lk",
                    "name": "Yo-Yo Ma",
                    "type": "artist",
                    "uri": "spotify:artist:5Dl3HXZjG6ZOWT5cV375lk"
                },
                {
                    "external_urls": {
                        "spotify": "https://open.spotify.com/artist/3rROvEsUJJ9y55g1PLaA16"
                    },
                    "href": "https://api.spotify.com/v1/artists/3rROvEsUJJ9y55g1PLaA16",
                    "id": "3rROvEsUJJ9y55g1PLaA16",
                    "name": "Robert Trujillo",
                    "type": "artist",
                    "uri": "spotify:artist:3rROvEsUJJ9y55g1PLaA16"
                },
                {
                    "external_urls": {
                        "spotify": "https://open.spotify.com/artist/4DW34vji6G9GgGY0k2mic7"
                    },
                    "href": "https://api.spotify.com/v1/artists/4DW34vji6G9GgGY0k2mic7",
                    "id": "4DW34vji6G9GgGY0k2mic7",
                    "name": "Chad Smith",
                    "type": "artist",
                    "uri": "spotify:artist:4DW34vji6G9GgGY0k2mic7"
                }
            ],
            "available_markets": [
                "CA",
                "PR",
                "US"
            ],
            "disc_number": 3,
            "duration_ms": 395785,
            "explicit": false,
            "external_urls": {
                "spotify": "https://open.spotify.com/track/3DVJIowTnVuq1PaCFkYVs1"
            },
            "href": "https://api.spotify.com/v1/tracks/3DVJIowTnVuq1PaCFkYVs1",
            "id": "3DVJIowTnVuq1PaCFkYVs1",
            "is_local": false,
            "name": "Nothing Else Matters",
            "preview_url": "https://p.scdn.co/mp3-preview/7a5f79dee3a7f96cea7c9dc0aabe9ea153c82aa8?cid=82a8a496c4904e3ebacd0a69657907e0",
            "track_number": 11,
            "type": "track",
            "uri": "spotify:track:3DVJIowTnVuq1PaCFkYVs1",
            "originals": [
                "2CtemffYhT0DJWcT1XW047"
            ]
        },
        {
            "artists": [
                {
                    "external_urls": {
                        "spotify": "https://open.spotify.com/artist/7hKXTmrq3ZppBx881yBbOr"
                    },
                    "href": "https://api.spotify.com/v1/artists/7hKXTmrq3ZppBx881yBbOr",
                    "id": "7hKXTmrq3ZppBx881yBbOr",
                    "name": "Dave Gahan",
                    "type": "artist",
                    "uri": "spotify:artist:7hKXTmrq3ZppBx881yBbOr"
                }
            ],
            "available_markets": [
                "CA",
                "PR",
                "US"
            ],
            "disc_number": 3,
            "duration_ms": 309373,
            "explicit": false,
            "external_urls": {
                "spotify": "https://open.spotify.com/track/2WVnpnOm2qptQ7F83Lg9Er"
            },
            "href": "https://api.spotify.com/v1/tracks/2WVnpnOm2qptQ7F83Lg9Er",
            "id": "2WVnpnOm2qptQ7F83Lg9Er",
            "is_local": false,
            "name": "Nothing Else Matters",
            "preview_url": "https://p.scdn.co/mp3-preview/70297fbcb41aaa347b6a4892f22656c7c868b24f?cid=82a8a496c4904e3ebacd0a69657907e0",
            "track_number": 12,
            "type": "track",
            "uri": "spotify:track:2WVnpnOm2qptQ7F83Lg9Er",
            "originals": [
                "2CtemffYhT0DJWcT1XW047"
            ]
        },
        {
            "artists": [
                {
                    "external_urls": {
                        "spotify": "https://open.spotify.com/artist/6nfN5B7Jmi853SHa9106Hz"
                    },
                    "href": "https://api.spotify.com/v1/artists/6nfN5B7Jmi853SHa9106Hz",
                    "id": "6nfN5B7Jmi853SHa9106Hz",
                    "name": "Mickey Guyton",
                    "type": "artist",
                    "uri": "spotify:artist:6nfN5B7Jmi853SHa9106Hz"
                }
            ],
            "available_markets": [
                "CA",
                "PR",
                "US"
            ],
            "disc_number": 3,
            "duration_ms": 270560,
            "explicit": false,
            "external_urls": {
                "spotify": "https://open.spotify.com/track/0pe91uoUarcvSkWJZw1Spx"
            },
            "href": "https://api.spotify.com/v1/tracks/0pe91uoUarcvSkWJZw1Spx",
            "id": "0pe91uoUarcvSkWJZw1Spx",
            "is_local": false,
            "name": "Nothing Else Matters",
            "preview_url": "https://p.scdn.co/mp3-preview/6924c832a14a285d64a4505be8e6a4a68dff40a7?cid=82a8a496c4904e3ebacd0a69657907e0",
            "track_number": 13,
            "type": "track",
            "uri": "spotify:track:0pe91uoUarcvSkWJZw1Spx",
            "originals": [
                "2CtemffYhT0DJWcT1XW047"
            ]
        },
        {
            "artists": [
                {
                    "external_urls": {
                        "spotify": "https://open.spotify.com/artist/5KNNVgR6LBIABRIomyCwKJ"
                    },
                    "href": "https://api.spotify.com/v1/artists/5KNNVgR6LBIABRIomyCwKJ",
                    "id": "5KNNVgR6LBIABRIomyCwKJ",
                    "name": "Dermot Kennedy",
                    "type": "artist",
                    "uri": "spotify:artist:5KNNVgR6LBIABRIomyCwKJ"
                }
            ],
            "available_markets": [
                "CA",
                "PR",
                "US"
            ],
            "disc_number": 3,
            "duration_ms": 181453,
            "explicit": false,
            "external_urls": {
                "spotify": "https://open.spotify.com/track/58HvvN5OGIKnjvG1o0pCNh"
            },
            "href": "https://api.spotify.com/v1/tracks/58HvvN5OGIKnjvG1o0pCNh",
            "id": "58HvvN5OGIKnjvG1o0pCNh",
            "is_local": false,
            "name": "Nothing Else Matters",
            "preview_url": "https://p.scdn.co/mp3-preview/20c923c6e5f797b9b954dcd0975b2b4e9f45cd6a?cid=82a8a496c4904e3ebacd0a69657907e0",
            "track_number": 14,
            "type": "track",
            "uri": "spotify:track:58HvvN5OGIKnjvG1o0pCNh",
            "originals": [
                "2CtemffYhT0DJWcT1XW047"
            ]
        },
        {
            "artists": [
                {
                    "external_urls": {
                        "spotify": "https://open.spotify.com/artist/4boI7bJtmB1L3b1cuL75Zr"
                    },
                    "href": "https://api.spotify.com/v1/artists/4boI7bJtmB1L3b1cuL75Zr",
                    "id": "4boI7bJtmB1L3b1cuL75Zr",
                    "name": "Mon Laferte",
                    "type": "artist",
                    "uri": "spotify:artist:4boI7bJtmB1L3b1cuL75Zr"
                }
            ],
            "available_markets": [
                "CA",
                "PR",
                "US"
            ],
            "disc_number": 3,
            "duration_ms": 356346,
            "explicit": false,
            "external_urls": {
                "spotify": "https://open.spotify.com/track/30bpDMMlPzCjGe7VIw294Y"
            },
            "href": "https://api.spotify.com/v1/tracks/30bpDMMlPzCjGe7VIw294Y",
            "id": "30bpDMMlPzCjGe7VIw294Y",
            "is_local": false,
            "name": "Nothing Else Matters",
            "preview_url": "https://p.scdn.co/mp3-preview/cc48e2faae0bb37da136da0db0c8f6902f135c5b?cid=82a8a496c4904e3ebacd0a69657907e0",
            "track_number": 15,
            "type": "track",
            "uri": "spotify:track:30bpDMMlPzCjGe7VIw294Y",
            "originals": [
                "2CtemffYhT0DJWcT1XW047"
            ]
        },
        {
            "artists": [
                {
                    "external_urls": {
                        "spotify": "https://open.spotify.com/artist/0japPUWMmW3gxqjSB1VEVL"
                    },
                    "href": "https://api.spotify.com/v1/artists/0japPUWMmW3gxqjSB1VEVL",
                    "id": "0japPUWMmW3gxqjSB1VEVL",
                    "name": "Igor Levit",
                    "type": "artist",
                    "uri": "spotify:artist:0japPUWMmW3gxqjSB1VEVL"
                }
            ],
            "available_markets": [
                "CA",
                "PR",
                "US"
            ],
            "disc_number": 4,
            "duration_ms": 312040,
            "explicit": false,
            "external_urls": {
                "spotify": "https://open.spotify.com/track/0ITPcAmJE8W3bvv9AuFSHh"
            },
            "href": "https://api.spotify.com/v1/tracks/0ITPcAmJE8W3bvv9AuFSHh",
            "id": "0ITPcAmJE8W3bvv9AuFSHh",
            "is_local": false,
            "name": "Nothing Else Matters",
            "preview_url": "https://p.scdn.co/mp3-preview/1ac03db9ef9487f4a9fc6f10cf69f57fc429421a?cid=82a8a496c4904e3ebacd0a69657907e0",
            "track_number": 1,
            "type": "track",
            "uri": "spotify:track:0ITPcAmJE8W3bvv9AuFSHh",
            "originals": [
                "2CtemffYhT0DJWcT1XW047"
            ]
        },
        {
            "artists": [
                {
                    "external_urls": {
                        "spotify": "https://open.spotify.com/artist/43O3c6wewpzPKwVaGEEtBM"
                    },
                    "href": "https://api.spotify.com/v1/artists/43O3c6wewpzPKwVaGEEtBM",
                    "id": "43O3c6wewpzPKwVaGEEtBM",
                    "name": "My Morning Jacket",
                    "type": "artist",
                    "uri": "spotify:artist:43O3c6wewpzPKwVaGEEtBM"
                }
            ],
            "available_markets": [
                "CA",
                "PR",
                "US"
            ],
            "disc_number": 4,
            "duration_ms": 206000,
            "explicit": false,
            "external_urls": {
                "spotify": "https://open.spotify.com/track/1wvSwSmksGs7riYIrrRt4K"
            },
            "href": "https://api.spotify.com/v1/tracks/1wvSwSmksGs7riYIrrRt4K",
            "id": "1wvSwSmksGs7riYIrrRt4K",
            "is_local": false,
            "name": "Nothing Else Matters",
            "preview_url": "https://p.scdn.co/mp3-preview/6a6c320545d72b21f60108e970ae2cf9dc9649b3?cid=82a8a496c4904e3ebacd0a69657907e0",
            "track_number": 2,
            "type": "track",
            "uri": "spotify:track:1wvSwSmksGs7riYIrrRt4K",
            "originals": [
                "2CtemffYhT0DJWcT1XW047"
            ]
        },
        {
            "artists": [
                {
                    "external_urls": {
                        "spotify": "https://open.spotify.com/artist/3k87PFuum7Sv7zzjw7BMIg"
                    },
                    "href": "https://api.spotify.com/v1/artists/3k87PFuum7Sv7zzjw7BMIg",
                    "id": "3k87PFuum7Sv7zzjw7BMIg",
                    "name": "PG Roxette",
                    "type": "artist",
                    "uri": "spotify:artist:3k87PFuum7Sv7zzjw7BMIg"
                }
            ],
            "available_markets": [
                "CA",
                "PR",
                "US"
            ],
            "disc_number": 4,
            "duration_ms": 228733,
            "explicit": false,
            "external_urls": {
                "spotify": "https://open.spotify.com/track/2J3izrYKxksPGM8U7v7iBz"
            },
            "href": "https://api.spotify.com/v1/tracks/2J3izrYKxksPGM8U7v7iBz",
            "id": "2J3izrYKxksPGM8U7v7iBz",
            "is_local": false,
            "name": "Nothing Else Matters",
            "preview_url": "https://p.scdn.co/mp3-preview/6546f61975d3a676848c554746b148a5ed3361df?cid=82a8a496c4904e3ebacd0a69657907e0",
            "track_number": 3,
            "type": "track",
            "uri": "spotify:track:2J3izrYKxksPGM8U7v7iBz",
            "originals": [
                "2CtemffYhT0DJWcT1XW047"
            ]
        },
        {
            "artists": [
                {
                    "external_urls": {
                        "spotify": "https://open.spotify.com/artist/7FY5V3XMwlNBPitEjXowHQ"
                    },
                    "href": "https://api.spotify.com/v1/artists/7FY5V3XMwlNBPitEjXowHQ",
                    "id": "7FY5V3XMwlNBPitEjXowHQ",
                    "name": "Darius Rucker",
                    "type": "artist",
                    "uri": "spotify:artist:7FY5V3XMwlNBPitEjXowHQ"
                }
            ],
            "available_markets": [
                "CA",
                "PR",
                "US"
            ],
            "disc_number": 4,
            "duration_ms": 412600,
            "explicit": false,
            "external_urls": {
                "spotify": "https://open.spotify.com/track/1vXhhour3gFxWB2xMXpioO"
            },
            "href": "https://api.spotify.com/v1/tracks/1vXhhour3gFxWB2xMXpioO",
            "id": "1vXhhour3gFxWB2xMXpioO",
            "is_local": false,
            "name": "Nothing Else Matters",
            "preview_url": "https://p.scdn.co/mp3-preview/1c9e5618687db0d5c468f54b14332a25b8b4a525?cid=82a8a496c4904e3ebacd0a69657907e0",
            "track_number": 4,
            "type": "track",
            "uri": "spotify:track:1vXhhour3gFxWB2xMXpioO",
            "originals": [
                "2CtemffYhT0DJWcT1XW047"
            ]
        },
        {
            "artists": [
                {
                    "external_urls": {
                        "spotify": "https://open.spotify.com/artist/4YLtscXsxbVgi031ovDDdh"
                    },
                    "href": "https://api.spotify.com/v1/artists/4YLtscXsxbVgi031ovDDdh",
                    "id": "4YLtscXsxbVgi031ovDDdh",
                    "name": "Chris Stapleton",
                    "type": "artist",
                    "uri": "spotify:artist:4YLtscXsxbVgi031ovDDdh"
                }
            ],
            "available_markets": [
                "CA",
                "PR",
                "US"
            ],
            "disc_number": 4,
            "duration_ms": 494800,
            "explicit": false,
            "external_urls": {
                "spotify": "https://open.spotify.com/track/2OzilO96UHULI7k5o0OXeD"
            },
            "href": "https://api.spotify.com/v1/tracks/2OzilO96UHULI7k5o0OXeD",
            "id": "2OzilO96UHULI7k5o0OXeD",
            "is_local": false,
            "name": "Nothing Else Matters",
            "preview_url": "https://p.scdn.co/mp3-preview/46f05416329c6e434f66abaaca1c6cc756c089ad?cid=82a8a496c4904e3ebacd0a69657907e0",
            "track_number": 5,
            "type": "track",
            "uri": "spotify:track:2OzilO96UHULI7k5o0OXeD",
            "originals": [
                "2CtemffYhT0DJWcT1XW047"
            ]
        },
        {
            "artists": [
                {
                    "external_urls": {
                        "spotify": "https://open.spotify.com/artist/5tYaRVYbV1anmzyxqMVdHi"
                    },
                    "href": "https://api.spotify.com/v1/artists/5tYaRVYbV1anmzyxqMVdHi",
                    "id": "5tYaRVYbV1anmzyxqMVdHi",
                    "name": "TRESOR",
                    "type": "artist",
                    "uri": "spotify:artist:5tYaRVYbV1anmzyxqMVdHi"
                }
            ],
            "available_markets": [
                "CA",
                "PR",
                "US"
            ],
            "disc_number": 4,
            "duration_ms": 384360,
            "explicit": false,
            "external_urls": {
                "spotify": "https://open.spotify.com/track/1K22F32vNIimlbSM3510Of"
            },
            "href": "https://api.spotify.com/v1/tracks/1K22F32vNIimlbSM3510Of",
            "id": "1K22F32vNIimlbSM3510Of",
            "is_local": false,
            "name": "Nothing Else Matters",
            "preview_url": "https://p.scdn.co/mp3-preview/57b9178c93c6e561dafb8a1d4305bdd15a2c3f57?cid=82a8a496c4904e3ebacd0a69657907e0",
            "track_number": 6,
            "type": "track",
            "uri": "spotify:track:1K22F32vNIimlbSM3510Of",
            "originals": [
                "2CtemffYhT0DJWcT1XW047"
            ]
        },
        {
            "artists": [
                {
                    "external_urls": {
                        "spotify": "https://open.spotify.com/artist/5ammRFhN6wQXM30xlhndC5"
                    },
                    "href": "https://api.spotify.com/v1/artists/5ammRFhN6wQXM30xlhndC5",
                    "id": "5ammRFhN6wQXM30xlhndC5",
                    "name": "Goodnight, Texas",
                    "type": "artist",
                    "uri": "spotify:artist:5ammRFhN6wQXM30xlhndC5"
                }
            ],
            "available_markets": [
                "CA",
                "PR",
                "US"
            ],
            "disc_number": 4,
            "duration_ms": 203733,
            "explicit": false,
            "external_urls": {
                "spotify": "https://open.spotify.com/track/6cbkOsqXiKY9LwE6zXBBzr"
            },
            "href": "https://api.spotify.com/v1/tracks/6cbkOsqXiKY9LwE6zXBBzr",
            "id": "6cbkOsqXiKY9LwE6zXBBzr",
            "is_local": false,
            "name": "Of Wolf and Man",
            "preview_url": "https://p.scdn.co/mp3-preview/7f9a343ed69b1f20501587f873e2d934647926e1?cid=82a8a496c4904e3ebacd0a69657907e0",
            "track_number": 7,
            "type": "track",
            "uri": "spotify:track:6cbkOsqXiKY9LwE6zXBBzr",
            "originals": [
                "55bio2ZtgCnUWsbANOEETT"
            ]
        },
        {
            "artists": [
                {
                    "external_urls": {
                        "spotify": "https://open.spotify.com/artist/75mafsNqNE1WSEVxIKuY5C"
                    },
                    "href": "https://api.spotify.com/v1/artists/75mafsNqNE1WSEVxIKuY5C",
                    "id": "75mafsNqNE1WSEVxIKuY5C",
                    "name": "IDLES",
                    "type": "artist",
                    "uri": "spotify:artist:75mafsNqNE1WSEVxIKuY5C"
                }
            ],
            "available_markets": [
                "CA",
                "PR",
                "US"
            ],
            "disc_number": 4,
            "duration_ms": 236226,
            "explicit": false,
            "external_urls": {
                "spotify": "https://open.spotify.com/track/29b12Xh1L6IeaqNJAdF1TM"
            },
            "href": "https://api.spotify.com/v1/tracks/29b12Xh1L6IeaqNJAdF1TM",
            "id": "29b12Xh1L6IeaqNJAdF1TM",
            "is_local": false,
            "name": "The God That Failed",
            "preview_url": "https://p.scdn.co/mp3-preview/faa24bad2eb465e41deae069c5d375650192dbaa?cid=82a8a496c4904e3ebacd0a69657907e0",
            "track_number": 8,
            "type": "track",
            "uri": "spotify:track:29b12Xh1L6IeaqNJAdF1TM",
            "originals": [
                "1O0GYt4Kak2eU6GXJuSYot"
            ]
        },
        {
            "artists": [
                {
                    "external_urls": {
                        "spotify": "https://open.spotify.com/artist/6AnjHMqEAps8VJdHU8RykH"
                    },
                    "href": "https://api.spotify.com/v1/artists/6AnjHMqEAps8VJdHU8RykH",
                    "id": "6AnjHMqEAps8VJdHU8RykH",
                    "name": "Imelda May",
                    "type": "artist",
                    "uri": "spotify:artist:6AnjHMqEAps8VJdHU8RykH"
                }
            ],
            "available_markets": [
                "CA",
                "PR",
                "US"
            ],
            "disc_number": 4,
            "duration_ms": 244306,
            "explicit": false,
            "external_urls": {
                "spotify": "https://open.spotify.com/track/3DEdpXX8k35cDJoGWvDREH"
            },
            "href": "https://api.spotify.com/v1/tracks/3DEdpXX8k35cDJoGWvDREH",
            "id": "3DEdpXX8k35cDJoGWvDREH",
            "is_local": false,
            "name": "The God That Failed",
            "preview_url": "https://p.scdn.co/mp3-preview/6617460cc0901feaee58220f9f0d89bb046c9671?cid=82a8a496c4904e3ebacd0a69657907e0",
            "track_number": 9,
            "type": "track",
            "uri": "spotify:track:3DEdpXX8k35cDJoGWvDREH",
            "originals": [
                "1O0GYt4Kak2eU6GXJuSYot"
            ]
        },
        {
            "artists": [
                {
                    "external_urls": {
                        "spotify": "https://open.spotify.com/artist/3pIGm1omCcHIb1juBNHspg"
                    },
                    "href": "https://api.spotify.com/v1/artists/3pIGm1omCcHIb1juBNHspg",
                    "id": "3pIGm1omCcHIb1juBNHspg",
                    "name": "Cherry Glazerr",
                    "type": "artist",
                    "uri": "spotify:artist:3pIGm1omCcHIb1juBNHspg"
                }
            ],
            "available_markets": [
                "CA",
                "PR",
                "US"
            ],
            "disc_number": 4,
            "duration_ms": 210653,
            "explicit": false,
            "external_urls": {
                "spotify": "https://open.spotify.com/track/0MMsevzxWNn78F1SCkKFdB"
            },
            "href": "https://api.spotify.com/v1/tracks/0MMsevzxWNn78F1SCkKFdB",
            "id": "0MMsevzxWNn78F1SCkKFdB",
            "is_local": false,
            "name": "My Friend of Misery",
            "preview_url": "https://p.scdn.co/mp3-preview/2d2b3c310b18f6c6c0cad8e2a83a01cfde2dbaa4?cid=82a8a496c4904e3ebacd0a69657907e0",
            "track_number": 10,
            "type": "track",
            "uri": "spotify:track:0MMsevzxWNn78F1SCkKFdB",
            "originals": [
                "6e9oTF6tSrSReHI6IcHZef"
            ]
        },
        {
            "artists": [
                {
                    "external_urls": {
                        "spotify": "https://open.spotify.com/artist/6T08mUIMB32dtqq5ryxQZ3"
                    },
                    "href": "https://api.spotify.com/v1/artists/6T08mUIMB32dtqq5ryxQZ3",
                    "id": "6T08mUIMB32dtqq5ryxQZ3",
                    "name": "Iz\u00efa",
                    "type": "artist",
                    "uri": "spotify:artist:6T08mUIMB32dtqq5ryxQZ3"
                }
            ],
            "available_markets": [
                "CA",
                "PR",
                "US"
            ],
            "disc_number": 4,
            "duration_ms": 264573,
            "explicit": false,
            "external_urls": {
                "spotify": "https://open.spotify.com/track/0sDTzlaTVrmOM0KLc7TSCv"
            },
            "href": "https://api.spotify.com/v1/tracks/0sDTzlaTVrmOM0KLc7TSCv",
            "id": "0sDTzlaTVrmOM0KLc7TSCv",
            "is_local": false,
            "name": "My Friend of Misery",
            "preview_url": "https://p.scdn.co/mp3-preview/2cef73e22e84c64773e8c45124c1c2ba28c42467?cid=82a8a496c4904e3ebacd0a69657907e0",
            "track_number": 11,
            "type": "track",
            "uri": "spotify:track:0sDTzlaTVrmOM0KLc7TSCv",
            "originals": [
                "6e9oTF6tSrSReHI6IcHZef"
            ]
        },
        {
            "artists": [
                {
                    "external_urls": {
                        "spotify": "https://open.spotify.com/artist/6HQYnRM4OzToCYPpVBInuU"
                    },
                    "href": "https://api.spotify.com/v1/artists/6HQYnRM4OzToCYPpVBInuU",
                    "id": "6HQYnRM4OzToCYPpVBInuU",
                    "name": "Kamasi Washington",
                    "type": "artist",
                    "uri": "spotify:artist:6HQYnRM4OzToCYPpVBInuU"
                }
            ],
            "available_markets": [
                "CA",
                "PR",
                "US"
            ],
            "disc_number": 4,
            "duration_ms": 407240,
            "explicit": false,
            "external_urls": {
                "spotify": "https://open.spotify.com/track/6FeKmeXJnvhy3h9aOC99HV"
            },
            "href": "https://api.spotify.com/v1/tracks/6FeKmeXJnvhy3h9aOC99HV",
            "id": "6FeKmeXJnvhy3h9aOC99HV",
            "is_local": false,
            "name": "My Friend of Misery",
            "preview_url": "https://p.scdn.co/mp3-preview/952fd286f3009f85ee27989ac85fb9dabf1cc1a1?cid=82a8a496c4904e3ebacd0a69657907e0",
            "track_number": 12,
            "type": "track",
            "uri": "spotify:track:6FeKmeXJnvhy3h9aOC99HV",
            "originals": [
                "6e9oTF6tSrSReHI6IcHZef"
            ]
        },
        {
            "artists": [
                {
                    "external_urls": {
                        "spotify": "https://open.spotify.com/artist/7vX3cMVyW8gtDA4y855ynF"
                    },
                    "href": "https://api.spotify.com/v1/artists/7vX3cMVyW8gtDA4y855ynF",
                    "id": "7vX3cMVyW8gtDA4y855ynF",
                    "name": "Rodrigo y Gabriela",
                    "type": "artist",
                    "uri": "spotify:artist:7vX3cMVyW8gtDA4y855ynF"
                }
            ],
            "available_markets": [
                "CA",
                "PR",
                "US"
            ],
            "disc_number": 4,
            "duration_ms": 239746,
            "explicit": false,
            "external_urls": {
                "spotify": "https://open.spotify.com/track/2RuQ5MBFCvFRYXyuAf8oSX"
            },
            "href": "https://api.spotify.com/v1/tracks/2RuQ5MBFCvFRYXyuAf8oSX",
            "id": "2RuQ5MBFCvFRYXyuAf8oSX",
            "is_local": false,
            "name": "The Struggle Within",
            "preview_url": "https://p.scdn.co/mp3-preview/6e46b424b0ab717a8d94061f8967ab206014dff0?cid=82a8a496c4904e3ebacd0a69657907e0",
            "track_number": 13,
            "type": "track",
            "uri": "spotify:track:2RuQ5MBFCvFRYXyuAf8oSX",
            "originals": [
                "4r0gODFlBlIZ12NsNf38qf"
            ]
        },

        {
        "artists": [
            {
                "external_urls": {
                    "spotify": "https://open.spotify.com/artist/2ye2Wgw4gimLv2eAKyk1NB"
                },
                "href": "https://api.spotify.com/v1/artists/2ye2Wgw4gimLv2eAKyk1NB",
                "id": "2ye2Wgw4gimLv2eAKyk1NB",
                "name": "Metallica",
                "type": "artist",
                "uri": "spotify:artist:2ye2Wgw4gimLv2eAKyk1NB"
            }
        ],
        "available_markets": [
            "CA",
            "PR",
            "US"
        ],
        "disc_number": 1,
        "duration_ms": 331560,
        "explicit": false,
        "external_urls": {
            "spotify": "https://open.spotify.com/track/3VqHuw0wFlIHcIPWkhIbdQ"
        },
        "href": "https://api.spotify.com/v1/tracks/3VqHuw0wFlIHcIPWkhIbdQ",
        "id": "3VqHuw0wFlIHcIPWkhIbdQ",
        "is_local": false,
        "name": "Enter Sandman (Remastered)",
        "preview_url": "https://p.scdn.co/mp3-preview/333dcef73eb5aa95a58ff521fa63d14861dfe2f5?cid=82a8a496c4904e3ebacd0a69657907e0",
        "track_number": 1,
        "type": "track",
        "uri": "spotify:track:3VqHuw0wFlIHcIPWkhIbdQ"
    },
    {
        "artists": [
            {
                "external_urls": {
                    "spotify": "https://open.spotify.com/artist/2ye2Wgw4gimLv2eAKyk1NB"
                },
                "href": "https://api.spotify.com/v1/artists/2ye2Wgw4gimLv2eAKyk1NB",
                "id": "2ye2Wgw4gimLv2eAKyk1NB",
                "name": "Metallica",
                "type": "artist",
                "uri": "spotify:artist:2ye2Wgw4gimLv2eAKyk1NB"
            }
        ],
        "available_markets": [
            "CA",
            "PR",
            "US"
        ],
        "disc_number": 1,
        "duration_ms": 324600,
        "explicit": false,
        "external_urls": {
            "spotify": "https://open.spotify.com/track/5UaDi8KzCGJqFfVAOBfXhi"
        },
        "href": "https://api.spotify.com/v1/tracks/5UaDi8KzCGJqFfVAOBfXhi",
        "id": "5UaDi8KzCGJqFfVAOBfXhi",
        "is_local": false,
        "name": "Sad But True (Remastered)",
        "preview_url": "https://p.scdn.co/mp3-preview/b524a437eaa3b3798fe2e651cfda5de7d4443f88?cid=82a8a496c4904e3ebacd0a69657907e0",
        "track_number": 2,
        "type": "track",
        "uri": "spotify:track:5UaDi8KzCGJqFfVAOBfXhi"
    },
    {
        "artists": [
            {
                "external_urls": {
                    "spotify": "https://open.spotify.com/artist/2ye2Wgw4gimLv2eAKyk1NB"
                },
                "href": "https://api.spotify.com/v1/artists/2ye2Wgw4gimLv2eAKyk1NB",
                "id": "2ye2Wgw4gimLv2eAKyk1NB",
                "name": "Metallica",
                "type": "artist",
                "uri": "spotify:artist:2ye2Wgw4gimLv2eAKyk1NB"
            }
        ],
        "available_markets": [
            "CA",
            "PR",
            "US"
        ],
        "disc_number": 1,
        "duration_ms": 227573,
        "explicit": false,
        "external_urls": {
            "spotify": "https://open.spotify.com/track/5VJ05rDJ2O4cECGNbWPi64"
        },
        "href": "https://api.spotify.com/v1/tracks/5VJ05rDJ2O4cECGNbWPi64",
        "id": "5VJ05rDJ2O4cECGNbWPi64",
        "is_local": false,
        "name": "Holier Than Thou (Remastered)",
        "preview_url": "https://p.scdn.co/mp3-preview/551d0bd6059d800eb5bcb14ab4c65d0feac264c0?cid=82a8a496c4904e3ebacd0a69657907e0",
        "track_number": 3,
        "type": "track",
        "uri": "spotify:track:5VJ05rDJ2O4cECGNbWPi64"
    },
    {
        "artists": [
            {
                "external_urls": {
                    "spotify": "https://open.spotify.com/artist/2ye2Wgw4gimLv2eAKyk1NB"
                },
                "href": "https://api.spotify.com/v1/artists/2ye2Wgw4gimLv2eAKyk1NB",
                "id": "2ye2Wgw4gimLv2eAKyk1NB",
                "name": "Metallica",
                "type": "artist",
                "uri": "spotify:artist:2ye2Wgw4gimLv2eAKyk1NB"
            }
        ],
        "available_markets": [
            "CA",
            "PR",
            "US"
        ],
        "disc_number": 1,
        "duration_ms": 387160,
        "explicit": false,
        "external_urls": {
            "spotify": "https://open.spotify.com/track/7lwvxYumAEo10lzAplRGXM"
        },
        "href": "https://api.spotify.com/v1/tracks/7lwvxYumAEo10lzAplRGXM",
        "id": "7lwvxYumAEo10lzAplRGXM",
        "is_local": false,
        "name": "The Unforgiven (Remastered)",
        "preview_url": "https://p.scdn.co/mp3-preview/8d88612fd8ab8f5176a2c6de3919fa449c981cde?cid=82a8a496c4904e3ebacd0a69657907e0",
        "track_number": 4,
        "type": "track",
        "uri": "spotify:track:7lwvxYumAEo10lzAplRGXM"
    },
    {
        "artists": [
            {
                "external_urls": {
                    "spotify": "https://open.spotify.com/artist/2ye2Wgw4gimLv2eAKyk1NB"
                },
                "href": "https://api.spotify.com/v1/artists/2ye2Wgw4gimLv2eAKyk1NB",
                "id": "2ye2Wgw4gimLv2eAKyk1NB",
                "name": "Metallica",
                "type": "artist",
                "uri": "spotify:artist:2ye2Wgw4gimLv2eAKyk1NB"
            }
        ],
        "available_markets": [
            "CA",
            "PR",
            "US"
        ],
        "disc_number": 1,
        "duration_ms": 404333,
        "explicit": false,
        "external_urls": {
            "spotify": "https://open.spotify.com/track/745sNpjWbAxo2MA2zSYbyD"
        },
        "href": "https://api.spotify.com/v1/tracks/745sNpjWbAxo2MA2zSYbyD",
        "id": "745sNpjWbAxo2MA2zSYbyD",
        "is_local": false,
        "name": "Wherever I May Roam (Remastered)",
        "preview_url": "https://p.scdn.co/mp3-preview/2c05f55a9ad01f487b8de80d31a1e1cd9fa8e345?cid=82a8a496c4904e3ebacd0a69657907e0",
        "track_number": 5,
        "type": "track",
        "uri": "spotify:track:745sNpjWbAxo2MA2zSYbyD"
    },
    {
        "artists": [
            {
                "external_urls": {
                    "spotify": "https://open.spotify.com/artist/2ye2Wgw4gimLv2eAKyk1NB"
                },
                "href": "https://api.spotify.com/v1/artists/2ye2Wgw4gimLv2eAKyk1NB",
                "id": "2ye2Wgw4gimLv2eAKyk1NB",
                "name": "Metallica",
                "type": "artist",
                "uri": "spotify:artist:2ye2Wgw4gimLv2eAKyk1NB"
            }
        ],
        "available_markets": [
            "CA",
            "PR",
            "US"
        ],
        "disc_number": 1,
        "duration_ms": 240160,
        "explicit": false,
        "external_urls": {
            "spotify": "https://open.spotify.com/track/0u9ORuO4xOQY5SHxNcvCnV"
        },
        "href": "https://api.spotify.com/v1/tracks/0u9ORuO4xOQY5SHxNcvCnV",
        "id": "0u9ORuO4xOQY5SHxNcvCnV",
        "is_local": false,
        "name": "Don't Tread on Me (Remastered)",
        "preview_url": "https://p.scdn.co/mp3-preview/8d0b1ec51c0893405a46f88c4b8fa83650465f1d?cid=82a8a496c4904e3ebacd0a69657907e0",
        "track_number": 6,
        "type": "track",
        "uri": "spotify:track:0u9ORuO4xOQY5SHxNcvCnV"
    },
    {
        "artists": [
            {
                "external_urls": {
                    "spotify": "https://open.spotify.com/artist/2ye2Wgw4gimLv2eAKyk1NB"
                },
                "href": "https://api.spotify.com/v1/artists/2ye2Wgw4gimLv2eAKyk1NB",
                "id": "2ye2Wgw4gimLv2eAKyk1NB",
                "name": "Metallica",
                "type": "artist",
                "uri": "spotify:artist:2ye2Wgw4gimLv2eAKyk1NB"
            }
        ],
        "available_markets": [
            "CA",
            "PR",
            "US"
        ],
        "disc_number": 1,
        "duration_ms": 244533,
        "explicit": false,
        "external_urls": {
            "spotify": "https://open.spotify.com/track/0Nl9491E3l4mDUBlHhuWpD"
        },
        "href": "https://api.spotify.com/v1/tracks/0Nl9491E3l4mDUBlHhuWpD",
        "id": "0Nl9491E3l4mDUBlHhuWpD",
        "is_local": false,
        "name": "Through the Never (Remastered)",
        "preview_url": "https://p.scdn.co/mp3-preview/4bf0e24f6605f981830fbf93c6ec8017d58f841e?cid=82a8a496c4904e3ebacd0a69657907e0",
        "track_number": 7,
        "type": "track",
        "uri": "spotify:track:0Nl9491E3l4mDUBlHhuWpD"
    },
    {
        "artists": [
            {
                "external_urls": {
                    "spotify": "https://open.spotify.com/artist/2ye2Wgw4gimLv2eAKyk1NB"
                },
                "href": "https://api.spotify.com/v1/artists/2ye2Wgw4gimLv2eAKyk1NB",
                "id": "2ye2Wgw4gimLv2eAKyk1NB",
                "name": "Metallica",
                "type": "artist",
                "uri": "spotify:artist:2ye2Wgw4gimLv2eAKyk1NB"
            }
        ],
        "available_markets": [
            "CA",
            "PR",
            "US"
        ],
        "disc_number": 1,
        "duration_ms": 388733,
        "explicit": false,
        "external_urls": {
            "spotify": "https://open.spotify.com/track/2CtemffYhT0DJWcT1XW047"
        },
        "href": "https://api.spotify.com/v1/tracks/2CtemffYhT0DJWcT1XW047",
        "id": "2CtemffYhT0DJWcT1XW047",
        "is_local": false,
        "name": "Nothing Else Matters (Remastered)",
        "preview_url": "https://p.scdn.co/mp3-preview/830f0b836bc20723462da06d1ff779f7b9499a7e?cid=82a8a496c4904e3ebacd0a69657907e0",
        "track_number": 8,
        "type": "track",
        "uri": "spotify:track:2CtemffYhT0DJWcT1XW047"
    },
    {
        "artists": [
            {
                "external_urls": {
                    "spotify": "https://open.spotify.com/artist/2ye2Wgw4gimLv2eAKyk1NB"
                },
                "href": "https://api.spotify.com/v1/artists/2ye2Wgw4gimLv2eAKyk1NB",
                "id": "2ye2Wgw4gimLv2eAKyk1NB",
                "name": "Metallica",
                "type": "artist",
                "uri": "spotify:artist:2ye2Wgw4gimLv2eAKyk1NB"
            }
        ],
        "available_markets": [
            "CA",
            "PR",
            "US"
        ],
        "disc_number": 1,
        "duration_ms": 256573,
        "explicit": false,
        "external_urls": {
            "spotify": "https://open.spotify.com/track/55bio2ZtgCnUWsbANOEETT"
        },
        "href": "https://api.spotify.com/v1/tracks/55bio2ZtgCnUWsbANOEETT",
        "id": "55bio2ZtgCnUWsbANOEETT",
        "is_local": false,
        "name": "Of Wolf and Man (Remastered)",
        "preview_url": "https://p.scdn.co/mp3-preview/aef6bdbe2783ce81616a8f5126901e42b4690580?cid=82a8a496c4904e3ebacd0a69657907e0",
        "track_number": 9,
        "type": "track",
        "uri": "spotify:track:55bio2ZtgCnUWsbANOEETT"
    },
    {
        "artists": [
            {
                "external_urls": {
                    "spotify": "https://open.spotify.com/artist/2ye2Wgw4gimLv2eAKyk1NB"
                },
                "href": "https://api.spotify.com/v1/artists/2ye2Wgw4gimLv2eAKyk1NB",
                "id": "2ye2Wgw4gimLv2eAKyk1NB",
                "name": "Metallica",
                "type": "artist",
                "uri": "spotify:artist:2ye2Wgw4gimLv2eAKyk1NB"
            }
        ],
        "available_markets": [
            "CA",
            "PR",
            "US"
        ],
        "disc_number": 1,
        "duration_ms": 308506,
        "explicit": false,
        "external_urls": {
            "spotify": "https://open.spotify.com/track/1O0GYt4Kak2eU6GXJuSYot"
        },
        "href": "https://api.spotify.com/v1/tracks/1O0GYt4Kak2eU6GXJuSYot",
        "id": "1O0GYt4Kak2eU6GXJuSYot",
        "is_local": false,
        "name": "The God That Failed (Remastered)",
        "preview_url": "https://p.scdn.co/mp3-preview/2ceb79326f734033181893b59085d44d28de2acd?cid=82a8a496c4904e3ebacd0a69657907e0",
        "track_number": 10,
        "type": "track",
        "uri": "spotify:track:1O0GYt4Kak2eU6GXJuSYot"
    },
    {
        "artists": [
            {
                "external_urls": {
                    "spotify": "https://open.spotify.com/artist/2ye2Wgw4gimLv2eAKyk1NB"
                },
                "href": "https://api.spotify.com/v1/artists/2ye2Wgw4gimLv2eAKyk1NB",
                "id": "2ye2Wgw4gimLv2eAKyk1NB",
                "name": "Metallica",
                "type": "artist",
                "uri": "spotify:artist:2ye2Wgw4gimLv2eAKyk1NB"
            }
        ],
        "available_markets": [
            "CA",
            "PR",
            "US"
        ],
        "disc_number": 1,
        "duration_ms": 409666,
        "explicit": false,
        "external_urls": {
            "spotify": "https://open.spotify.com/track/6e9oTF6tSrSReHI6IcHZef"
        },
        "href": "https://api.spotify.com/v1/tracks/6e9oTF6tSrSReHI6IcHZef",
        "id": "6e9oTF6tSrSReHI6IcHZef",
        "is_local": false,
        "name": "My Friend of Misery (Remastered)",
        "preview_url": "https://p.scdn.co/mp3-preview/36bd076d5d5a999df3ac267e0aa0a1fcffdb93ec?cid=82a8a496c4904e3ebacd0a69657907e0",
        "track_number": 11,
        "type": "track",
        "uri": "spotify:track:6e9oTF6tSrSReHI6IcHZef"
    },
    {
        "artists": [
            {
                "external_urls": {
                    "spotify": "https://open.spotify.com/artist/2ye2Wgw4gimLv2eAKyk1NB"
                },
                "href": "https://api.spotify.com/v1/artists/2ye2Wgw4gimLv2eAKyk1NB",
                "id": "2ye2Wgw4gimLv2eAKyk1NB",
                "name": "Metallica",
                "type": "artist",
                "uri": "spotify:artist:2ye2Wgw4gimLv2eAKyk1NB"
            }
        ],
        "available_markets": [
            "CA",
            "PR",
            "US"
        ],
        "disc_number": 1,
        "duration_ms": 232648,
        "explicit": false,
        "external_urls": {
            "spotify": "https://open.spotify.com/track/4r0gODFlBlIZ12NsNf38qf"
        },
        "href": "https://api.spotify.com/v1/tracks/4r0gODFlBlIZ12NsNf38qf",
        "id": "4r0gODFlBlIZ12NsNf38qf",
        "is_local": false,
        "name": "The Struggle Within (Remastered)",
        "preview_url": "https://p.scdn.co/mp3-preview/7e3844eb5b47451fdc0d4a0f77bc24ff1efaff86?cid=82a8a496c4904e3ebacd0a69657907e0",
        "track_number": 12,
        "type": "track",
        "uri": "spotify:track:4r0gODFlBlIZ12NsNf38qf"
    }

    ]
)